"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3556],{

/***/ 13233:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var __jsx = _react["default"].createElement;
var Autopay = function Autopay(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M17.924 10.793c0-5.111-3.872-9.254-8.962-9.254S0 5.682 0 10.793v18.508h2.24c0-3.833 3.01-6.94 6.722-6.94 3.712 0 6.722 3.108 6.722 6.94h2.24V10.793z",
    fill: "#199BFA"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.402 0l-5.755 29.302h5.11l1.112-6.434h6.35l1.111 6.434h5.26L37.833 0h-7.432zm1.181 18.852l2.46-14.14 2.46 14.14h-4.92z",
    fill: "#282828"
  }), __jsx("path", {
    d: "M54.968 22.58c0 2.09-1.151 3.116-2.7 3.116-1.547 0-2.222-.902-2.222-2.829V7.868h-4.922v15.655c0 4.18 2.064 6.147 5.08 6.147 2.461 0 3.97-1.27 4.764-3.033V29.3h4.921V7.868h-4.921v14.713zM62.811 3.565h4.921V7.87h3.374v3.73h-3.374v11.72c0 1.475.595 2.13 1.865 2.13.636 0 1.23-.082 1.509-.205v3.893c-.397.164-1.35.328-2.46.328-4.089 0-5.835-1.885-5.835-5.737V3.565z",
    fill: "#282828"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.424 7.5c-4.524 0-7.779 2.745-7.779 8.032v6.188c0 5.205 3.255 7.95 7.74 7.95 4.484 0 7.897-2.745 7.897-8.032V15.45c0-5.246-3.294-7.95-7.858-7.95zm2.898 14.344c0 2.622-.952 3.934-2.898 3.934-1.945 0-2.858-1.312-2.858-3.934v-6.557c0-2.663.993-3.934 2.858-3.934 1.865 0 2.898 1.27 2.898 3.975v6.516zM95.664 10.492c.834-1.64 2.46-2.992 4.842-2.992 3.532 0 5.874 2.458 5.874 7.58v6.927c0 5.164-2.461 7.663-6.072 7.663-2.303 0-3.93-1.188-4.644-2.827V36h-4.922V7.87h4.922v2.622zm2.976 15.327c1.826 0 2.779-1.189 2.779-3.77v-6.967c0-2.663-1.033-3.688-2.78-3.688-1.904 0-3.016 1.352-3.016 4.016v6.352c0 2.663.993 4.057 3.017 4.057zM119.244 10.328c-.754-1.721-2.143-2.828-4.445-2.828-3.493 0-6.112 2.5-6.112 7.704v6.804c0 5.204 2.46 7.663 5.874 7.663 2.381 0 3.889-1.352 4.683-3.074v2.705h4.922V7.869h-4.922v2.46zm.04 11.393c0 2.663-1.112 4.057-3.017 4.057-1.667 0-2.619-1.066-2.619-3.688v-6.967c0-2.664.952-3.812 2.739-3.812 1.905 0 2.898 1.394 2.898 4.14l-.001 6.27z",
    fill: "#282828"
  }), __jsx("path", {
    d: "M134.043 20.9l3.135-13.032H142L134.027 36h-4.938l2.454-8.42-5.994-19.712h5.239l3.255 13.032z",
    fill: "#282828"
  }));
};
Autopay.defaultProps = {
  viewBox: "0 0 142 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Paypal = function Paypal(props) {
  return __jsx("svg", props, __jsx("rect", {
    rx: "15%",
    fill: "none"
  }), __jsx("path", {
    fill: "#002c8a",
    d: "M377 184.8L180.7 399h-72c-5 0-9-5-8-10l48-304c1-7 7-12 14-12h122c84 3 107 46 92 112z"
  }), __jsx("path", {
    fill: "#009be1",
    d: "M380.2 165c30 16 37 46 27 86-13 59-52 84-109 85l-16 1c-6 0-10 4-11 10l-13 79c-1 7-7 12-14 12h-60c-5 0-9-5-8-10l22-143c1-5 182-120 182-120z"
  }), __jsx("path", {
    fill: "#001f6b",
    d: "M197 292l20-127a14 14 0 0 1 13-11h96c23 0 40 4 54 11-5 44-26 115-128 117h-44c-5 0-10 4-11 10z"
  }));
};
Paypal.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};
var Przelewy24 = function Przelewy24(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D13239",
    d: "M409.6 384.9l156.4-.2-5.7 35.6-130.8 124.9 109.8-.2-6.4 38.4-161.7.1 6.8-39.7 125.4-120.1H403.3l6.3-38.8zM238.5 324c-3.4-3.6-8.3-6.4-13.7-8.6-5.7-2.2-12-3.8-18.2-4.9-7.8-1.4-15.4-2-20.8-2.2-5-.2-8.2-.2-8.2-.2H58.3L12.7 583.5h42.6l16.8-102 82.6.4s32.2 1.3 55-10.8c22.8-12.1 28.9-39.6 28.9-39.6s2.5-10.2 4.6-22.6c2.3-13.7 4.6-30.1 5.8-38.8.5-3.8.8-6.2.8-6.2s.6-2.8.6-7.2c.1-6.1-.8-15.3-5.6-24.1-1.7-3.1-3.7-5.9-6.3-8.6zm-32.8 48.6c0 .5-3.8 22.6-8.8 48.8-1.9 10-9.6 15.4-18.4 17.3-14.6 3.1-30.3 2.5-30.3 2.5l-69-.2 15.2-91.5 62.5.2s4.2-.1 10.1 0c6.7.1 15.6.4 22.9 1.4 6.3.8 11.3 2.1 12.9 4.1 2.1 2.6 2.9 6 3.2 9 .4 4.4-.3 8.1-.3 8.4zM778.1 308.1h41l-45.9 275.4-41.1-.1 46-275.3zM996.9 384.9l39.3-.1 13.9 139.8 60.5-140 48.5.1 14.3 140.4 60.4-140.3h40.8L1188 583.3h-48.4l-14-139-61.1 139-47.6.2-20-198.6z"
  }), __jsx("g", {
    fill: "#D13239"
  }, __jsx("path", {
    d: "M702.4 386.5c-11.5-3.7-31.4-4.5-48.3-4.3-16.3.2-23.8 1-29.9 2.3 0 0-29 4.2-45.5 24.6-16.5 20.4-21.4 65-21.4 65s-9.8 49.3-6.9 65.8c2.9 16.4 8 31.7 26.6 38.8 18.6 7.2 34.4 6.8 34.4 6.8s33.2 2.6 58.2-3.3 38.2-23.5 38.2-23.5 5.9-7.6 10.1-16.6c4.2-9 5.5-15.3 5.7-16.1l2.6-10.7-42.5.1s-2.3 28.1-25.3 30.7c-22.9 2.6-35.2 1.6-39.7 1.4-4.4-.2-29 .9-27-19.7 0-.3 0-.7.1-1.3 1.1-23.4 3.7-29.5 3.7-29.5l133.5-.4 5.7-33c6.6-37.4 1.9-65.9-32.3-77.1zm-8.9 72.4l-91.5-.1 3.6-14.5s3.2-11.4 9.5-16.2c6.4-4.8 14.5-5.7 22.1-6.4 7.6-.7 27.9-2.2 44.4 1.2 5.5 1.1 10.7 4.2 12.1 8.8 3.2 10.8-.2 27.2-.2 27.2z"
  }), __jsx("path", {
    d: "M592 526.9c0 .3-.1.6-.1.9-.1 1.6.1-1 .1-.9z"
  })), __jsx("g", {
    fill: "#D13239"
  }, __jsx("path", {
    d: "M843.8 527c0 .3-.1.6-.1.9 0 1.6.1-1 .1-.9z"
  }), __jsx("path", {
    d: "M954.3 386.6c-11.5-3.7-31.4-4.5-48.3-4.3-16.3.2-23.8 1-29.9 2.3 0 0-29 4.2-45.5 24.6-16.5 20.4-21.4 65-21.4 65s-9.8 49.3-6.9 65.8c2.9 16.4 8 31.7 26.6 38.8 18.6 7.2 34.4 6.8 34.4 6.8s33.2 2.6 58.2-3.3 38.2-23.5 38.2-23.5 5.9-7.6 10.1-16.6c4.2-9 5.5-15.3 5.7-16.1l2.6-10.7-42.5.1s-2.3 28.1-25.3 30.7c-22.9 2.6-35.2 1.6-39.7 1.5-4.4-.2-29 .8-27-19.7 0-.3 0-.7.1-1.3 1.1-23.4 3.7-29.5 3.7-29.5l133.5-.4 5.7-33c6.6-37.5 1.9-66.1-32.3-77.2zm-9.3 72.3l-91.5-.1 3.6-14.5s3.2-11.4 9.5-16.2c6.3-4.8 14.5-5.7 22.1-6.4 7.6-.7 27.9-2.2 44.4 1.2 5.5 1.1 10.7 4.2 12.1 8.8 3.2 10.7-.2 27.2-.2 27.2z"
  })), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D13239",
    d: "M1321.8 384.9l26.3 145.2 74.3-145.3 41.8.4-107.1 207.5s-19.4 37.6-31.4 47.1-19.4 13.8-29.2 14.8-13.8 1.7-23.2 0l-10-1.8 6.2-37.1s16.6 3.1 26.4-.8c9.9-3.9 17.8-20.7 17.8-20.7l5-8.4-38.7-201 41.8.1z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B3B2B1",
    d: "M1479.4 404.6l43.1.1 2.6-16.7s4.6-30.2 14.9-36c3.3-1.9 8.6-3.6 14.7-4.7 11.3-2 25.6-2.2 37.3-1.8 17.9.6 24.7.8 42.9 2.9 18.2 2.1 13.6 19.7 13.6 19.7l-3.6 26.3s-1.6 11.8-5.8 19.1c-3.7 6.5-13.9 10.9-19.8 12.8-14.2 4.6-62.8 17-62.8 17l-38.2 11s-23.5 6.8-36.6 21.3c-13.2 14.6-18.4 31.1-20.2 39.7-1.8 8.6-11.9 68.1-11.9 68.1l206.2.1 6.9-41.2-163.1.2 2.9-16.8s1.9-17.3 8.9-23c2.2-1.8 3.3-4.2 16.3-8.8 7.8-2.8 34.4-9.9 34.4-9.9l61.5-16.8s33.6-8.6 46.8-27c13.2-18.3 18.3-53.4 18.3-53.4s3.6-34.1.8-44.8c-2.7-10.7-12.8-23.5-25.1-29s-25.1-8.7-62.2-8.2-55.5 2.2-74.3 9.2c-18.8 6.9-29.7 19.5-36.6 37.3-7.5 16.9-11.9 53.3-11.9 53.3zM1867.6 481.2l28.9-173.2h-51.2l-159.4 171.2-7.2 43.4h139.4l-10.2 60.8 42.8.1 10.1-60.9 39.5.1 7.1-41.5h-39.8zm-42.6.1l-90.1-.1 109.7-116.9-19.6 117zM328.9 330.8h131.3s29.4-23.8 50.3-39.1 58.9-39.4 58.9-39.4l-74.2-34.7s-62.7 38.8-89.3 57.1c-25.8 16.9-77 56.1-77 56.1zM611.1 227.8l-60.9-41s55.1-31.3 128.4-60.5c73.2-29.2 112.3-41.4 112.3-41.4l12.4 58.1s-70.5 23.6-110.9 42.7c-41.8 17.8-81.3 42.1-81.3 42.1zM848.3 130.3l-10.6-59.5s75.2-20 144-32.8c68.9-12.8 160.2-18.9 160.2-18.9l-30.2 91.9s-80.3-11-155.7-.7c-58.7 7-107.7 20-107.7 20zM1159.5 118.8l50.8-102.1s111.3-2.2 207.3 12.7c96 14.8 183.8 37.6 181.9 38.6l-243.4 127.3s-56.9-36-127.5-58.1c-40-11.8-69.1-18.4-69.1-18.4zM1399.7 223l53.5 40.6h439.7s-.9-14.2-12.6-34.4c-7.3-12.6-20.6-26-34.5-39.9-5.1-5-25.3-20.8-40.5-30.7-38.8-25.2-60.5-34.9-100.8-53.2L1399.7 223z"
  }), __jsx("path", {
    fill: "#D13239",
    d: "M357.4 384.7c-16.5 0-32.1 6.5-45.4 13.8l2.3-13.8h-43.7l-35 197.7h43.8l19.4-109.5c4-22.2 20.6-49.7 53-49.7l22.6-.1 6.8-38.4h-23.8z"
  }));
};
Przelewy24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1920 672"
};
var Blik = function Blik(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.63C0 .73.733 0 1.634 0h32.601c.903 0 1.635.735 1.635 1.63v21.74c0 .9-.733 1.63-1.635 1.63h-32.6A1.636 1.636 0 0 1 0 23.37V1.63z",
    fill: "#262626"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.145 18.847h2.182V6.618h-2.183v12.229zM19.191 18.846h2.183v-8.1h-2.183v8.1zM31.158 18.847l-3.28-4.287 3.017-3.813h-2.577l-2.893 3.7V6.617h-2.183v12.229h2.183v-4.159l2.893 4.159h2.84zM9.58 16.756a1.96 1.96 0 1 1 0-3.918 1.96 1.96 0 0 1 0 3.918zm0-6.1c-.71 0-1.376.178-1.96.491V6.618H5.437v8.179a4.142 4.142 0 1 0 4.142-4.142z",
    fill: "#FFFFFE"
  }), __jsx("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: "9",
    y: "6",
    width: "5",
    height: "4"
  }, __jsx("path", {
    d: "M13.658 7.96a1.946 1.946 0 1 1-3.892 0 1.946 1.946 0 0 1 3.892 0z",
    fill: "#fff"
  })), __jsx("g", {
    mask: "url(#a)"
  }, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.658 7.96a1.946 1.946 0 1 1-3.892 0 1.946 1.946 0 0 1 3.892 0z",
    fill: "url(#b)"
  })), __jsx("defs", null, __jsx("linearGradient", {
    id: "b",
    x1: "10.455",
    y1: "6.013",
    x2: "12.97",
    y2: "9.905",
    gradientUnits: "userSpaceOnUse"
  }, __jsx("stop", {
    stopColor: "#E43319"
  }), __jsx("stop", {
    offset: "1",
    stopColor: "#E94D8E"
  }))));
};
Blik.defaultProps = {
  viewBox: "0 0 36 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Visa = function Visa(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M16.539 9.186a4.155 4.155 0 0 0-1.451-.251c-1.6 0-2.73.806-2.738 1.963-.01.85.803 1.329 1.418 1.613.631.292.842.476.84.737-.004.397-.504.577-.969.577-.639 0-.988-.089-1.525-.312l-.199-.093-.227 1.332c.389.162 1.09.301 1.814.313 1.701 0 2.813-.801 2.826-2.032.014-.679-.426-1.192-1.352-1.616-.563-.275-.912-.459-.912-.738 0-.247.299-.511.924-.511a2.95 2.95 0 0 1 1.213.229l.15.067.227-1.287-.039.009zm4.152-.143h-1.25c-.389 0-.682.107-.852.493l-2.404 5.446h1.701l.34-.893 2.076.002c.049.209.199.891.199.891h1.5l-1.31-5.939zm-10.642-.05h1.621l-1.014 5.942H9.037l1.012-5.944v.002zm-4.115 3.275l.168.825 1.584-4.05h1.717l-2.551 5.931H5.139l-1.4-5.022a.339.339 0 0 0-.149-.199 6.948 6.948 0 0 0-1.592-.589l.022-.125h2.609c.354.014.639.125.734.503l.57 2.729v-.003zm12.757.606l.646-1.662c-.008.018.133-.343.215-.566l.111.513.375 1.714H18.69v.001h.001z"
  }));
};
Visa.defaultProps = {
  fill: "#254aa5",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var MasterCard = function MasterCard(props) {
  return __jsx("svg", props, __jsx("defs", null, __jsx("style", null, ".cls-1", "{", "fill:none", "}", ".cls-2", "{", "clip-path:url(#clip-path)", "}", ".cls-3", "{", "fill:#f79410", "}", ".cls-3,.cls-4,.cls-5", "{", "fill-rule:evenodd", "}", ".cls-4", "{", "fill:#ff5f00", "}", ".cls-5", "{", "fill:#eb001b", "}")), __jsx("g", {
    className: "cls-2"
  }, __jsx("path", {
    className: "cls-3",
    d: "M305.54 154.43v-3.7h-1l-1.12 2.54-1.11-2.54h-1v3.7h.69v-2.79l1 2.41h.71l1.05-2.42v2.8zm-6.11 0v-3.07h1.23v-.62h-3.15v.62h1.23v3.07z",
    transform: "translate(.03 .04)"
  }), __jsx("path", {
    className: "cls-4",
    d: "M196 170.31h-83.45V20.38H196z",
    transform: "translate(.03 .04)"
  }), __jsx("path", {
    className: "cls-5",
    d: "M117.84 95.35a95.18 95.18 0 0 1 36.41-75 95.35 95.35 0 1 0 0 149.92 95.18 95.18 0 0 1-36.41-75",
    transform: "translate(.03 .04)"
  }), __jsx("path", {
    className: "cls-3",
    d: "M308.52 95.35a95.34 95.34 0 0 1-154.26 75 95.35 95.35 0 0 0 0-149.92 95.34 95.34 0 0 1 154.26 75",
    transform: "translate(.03 .04)"
  })));
};
MasterCard.defaultProps = {
  id: "Warstwa_1",
  "'data-name'": "Warstwa 1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  height: "38",
  viewBox: "0 0 308.55 190.78"
};
var Inpost = function Inpost(props) {
  return __jsx("svg", props, __jsx("style", null, ".inp0", "{", "fill:#404042", "}", ".inp1", "{", "fill:#fff", "}", ".inp2", "{", "fill:#feca09", "}"), __jsx("path", {
    className: "inp0",
    d: "M1.14 36.47h60.29v16.78H1.14z"
  }), __jsx("path", {
    className: "inp1",
    d: "M13.83 45.81l-1.57 1.61v2.52h-1.83v-9.87h1.83v5.06l4.88-5.06h2.06l-4.15 4.41 4.41 5.46h-2.15zM27.47 42.41v7.53h-1.68v-.96c-.56.69-1.45 1.06-2.43 1.06-1.93 0-3.24-1.06-3.24-3.33v-4.3h1.76v4.06c0 1.37.65 2.02 1.76 2.02 1.23 0 2.06-.76 2.06-2.27v-3.81h1.77zM33.75 42.32V44c-.16-.03-.28-.04-.41-.04-1.34 0-2.19.79-2.19 2.33v3.65h-1.76v-7.53h1.68v1.1c.5-.79 1.42-1.19 2.68-1.19M35.15 40.11c0-.59.48-1.06 1.13-1.06.65 0 1.13.44 1.13 1.02 0 .62-.47 1.1-1.13 1.1-.65 0-1.13-.47-1.13-1.06m.24 2.3h1.76v7.53h-1.76v-7.53zM46.2 46.74h-5.91c.21 1.1 1.13 1.81 2.44 1.81.85 0 1.51-.27 2.05-.82l.94 1.09c-.68.8-1.74 1.23-3.03 1.23-2.53 0-4.16-1.62-4.16-3.87 0-2.24 1.65-3.85 3.89-3.85 2.2 0 3.81 1.54 3.81 3.89 0 .14-.02.35-.03.52m-5.93-1.17h4.28c-.14-1.09-.97-1.83-2.13-1.83-1.15 0-1.98.73-2.15 1.83M51.95 42.32V44c-.16-.03-.28-.04-.41-.04-1.34 0-2.19.79-2.19 2.33v3.65h-1.76v-7.53h1.68v1.1c.5-.79 1.42-1.19 2.68-1.19"
  }), __jsx("g", null, __jsx("path", {
    className: "inp2",
    d: "M1.14.61h96.93v35.86H1.14z"
  }), __jsx("path", {
    className: "inp0",
    d: "M31.19 29.48h-3.51v-10.1c0-2.12-.93-3.27-2.63-3.4-1.06-.08-2.74.17-3.96.44v13.06h-3.51V13.93s4.27-.95 8.11-.95c1.67 0 3 .6 4 1.6s1.49 2.39 1.49 4.18v10.72zM90.32 29.59c-.57.15-1.17.22-1.79.22-1.97 0-3.29-.45-3.92-1.32-.51-.69-.76-2.01-.76-3.94V8.36h3.46v4.57h3.07v2.84h-3.07v8.56c0 .93.12 1.54.35 1.83.28.37.87.57 1.77.57.25 0 .55-.03.89-.07v2.93zM10.54 8.35h3.57v21.12h-3.57zM46.39 15.56c0-2.56-1.25-3.84-3.75-3.84h-4.41v7.62h4.35c1.19 0 2.13-.33 2.8-1 .67-.65 1.01-1.58 1.01-2.78m3.61 0c0 2.16-.67 3.9-2 5.21-1.34 1.31-3.15 1.96-5.44 1.96h-4.33v6.67h-3.57V8.29h7.65c2.48 0 4.38.64 5.7 1.94 1.32 1.29 1.99 3.06 1.99 5.33M62.93 21.11c0-1.59-.37-2.85-1.11-3.78-.74-.93-1.71-1.39-2.93-1.39s-2.2.47-2.93 1.41c-.74.95-1.1 2.2-1.1 3.77 0 1.59.36 2.85 1.1 3.79.74.93 1.71 1.4 2.93 1.4s2.2-.46 2.93-1.4c.74-.95 1.11-2.21 1.11-3.8m3.61-.01c0 2.54-.71 4.59-2.13 6.14-1.42 1.55-3.26 2.33-5.53 2.33-2.26 0-4.11-.78-5.53-2.33s-2.13-3.6-2.13-6.14.71-4.58 2.13-6.13c1.42-1.54 3.26-2.31 5.53-2.31 2.29 0 4.13.78 5.55 2.31 1.41 1.55 2.11 3.59 2.11 6.13M81.77 24.02c0 1.6-.62 2.91-1.86 3.94-1.24 1.03-2.87 1.54-4.9 1.54-3.16 0-5.61-.94-7.34-2.83l2.66-2.24c1.32 1.3 2.87 1.95 4.65 1.95.99 0 1.76-.19 2.34-.58.57-.39.87-.87.87-1.47 0-.67-.33-1.14-1-1.38-.39-.15-1.41-.34-3.08-.6-2.01-.29-3.44-.74-4.29-1.32-1-.71-1.5-1.78-1.5-3.21 0-1.45.61-2.66 1.82-3.64 1.22-.97 2.84-1.46 4.88-1.46 2.45 0 4.55.81 6.27 2.42l-2.08 2.2c-1.26-1.11-2.69-1.67-4.3-1.67-2.05 0-3.08.58-3.08 1.73 0 .67.47 1.13 1.41 1.38 1.33.21 2.64.43 3.94.66 3.07.58 4.59 2.11 4.59 4.58"
  })));
};
Inpost.defaultProps = {
  id: "Warstwa_1",
  xmlns: "http://www.w3.org/2000/svg",
  height: "30",
  width: "60",
  viewBox: "0 0 99.21 53.86"
};
var Dhl = function Dhl(props) {
  return __jsx("svg", props, __jsx("style", null, ".dhl0", "{", "fill:#d40511", "}"), __jsx("path", {
    className: "dhl0",
    d: "M0 18.5h17.4l-1 1.4H0v-1.4zM143.5 19.9h-21.3l1.1-1.4h20.3v1.4zM0 15.9h19.4l-1.1 1.4H0v-1.4zM0 13.3h21.4l-1.1 1.4H0v-1.4zM143.5 17.3h-19.3l1.1-1.4h18.3v1.4zM127.2 13.3h16.3v1.4h-17.4l1.1-1.4zM18.8 19.9L28 7.6h11.4c1.3 0 1.3.5.6 1.3-.6.8-1.7 2.3-2.3 3.1-.3.5-.9 1.2 1 1.2H54C52.8 15 48.6 20 41.2 20c-6-.1-22.4-.1-22.4-.1zM71.5 13.3l-5 6.7H53.4l5-6.7h13.1zM90.6 13.3l-5 6.7H72.4l5-6.7h13.2zM94.9 13.3s-1 1.3-1.4 1.9c-1.7 2.2-.2 4.8 5.2 4.8h21.2l5-6.7h-30z"
  }), __jsx("path", {
    className: "dhl0",
    d: "M25.3 0l-4.6 6.1h25c1.3 0 1.3.5.6 1.3-.6.8-1.7 2.3-2.3 3.1-.3.4-.9 1.2 1 1.2h10.2s1.7-2.2 3-4.1c1.9-2.5.2-7.7-6.5-7.7-6 .1-26.4.1-26.4.1zM91.7 11.7H59.5L68.3 0h13.2l-5 6.7h5.9l5-6.7h13.2l-8.9 11.7zM118.8 0L110 11.7H96L104.8 0h14z"
  }));
};
Dhl.defaultProps = {
  id: "dhl_logo",
  xmlns: "http://www.w3.org/2000/svg",
  width: "143.5",
  height: "20",
  viewBox: "0 0 143.5 20"
};
var Dpd = function Dpd(props) {
  return __jsx("svg", props, __jsx("path", {
    fill: "#414042",
    d: "M372.345 441.876c-8.398 2.223-19.338 3.323-28.849 3.323-24.413 0-40.579-12.992-40.579-36.771 0-22.505 15.057-37.083 37.094-37.083 4.912 0 10.14.625 13.313 2.216v-32.668h19.021v100.983zm-19.021-51.516c-3.013-1.426-6.974-2.219-11.737-2.219-11.563 0-19.333 7.136-19.333 19.656 0 13.476 8.399 21.087 21.874 21.087 2.379 0 6.023-.163 9.196-.793V390.36zm175.107 51.516c-8.406 2.223-19.343 3.323-28.854 3.323-24.409 0-40.584-12.992-40.584-36.771 0-22.505 15.064-37.083 37.101-37.083 4.913 0 10.144.625 13.315 2.216v-32.668h19.021v100.983zm-19.022-51.516c-3.016-1.426-6.979-2.219-11.733-2.219-11.57 0-19.336 7.136-19.336 19.656 0 13.476 8.399 21.087 21.874 21.087 2.375 0 6.023-.163 9.195-.793V390.36zm-107.151-.156c3.168-1.271 7.6-1.742 11.404-1.742 11.733 0 19.818 6.814 19.818 19.015 0 14.393-8.955 20.902-20.929 21.07v16.642c.314 0 .634.011.957.011 24.565 0 39.312-13.785 39.312-38.354 0-22.35-15.691-35.501-38.836-35.501-11.727 0-23.304 2.695-30.91 5.862v94.953h19.184v-81.956z"
  }), __jsx("path", {
    fill: "#d30032",
    d: "M199.681 385.541c-.787.459-2.021.423-2.789-.052l-4.522-2.688c-.368-.228-.706-.593-.961-1.032l-.045-.077c-.289-.471-.453-.968-.47-1.424l-.115-5.272c-.034-.888.552-1.971 1.342-2.432l54.362-31.67-76.285-41.577c-.84-.466-1.948-.691-3.057-.693-1.11-.002-2.22.229-3.061.693l-76.286 41.578 85.46 49.75c.792.433 1.394 1.461 1.394 2.389v72.576c0 .911-.652 1.958-1.45 2.384l-4.599 2.554c-.382.203-.868.312-1.376.312h-.088c-.552.013-1.065-.096-1.467-.312l-4.614-2.555c-.784-.417-1.425-1.469-1.425-2.383l.001-64.698c-.041-.474-.388-1.052-.768-1.27L83.57 355.813v85.848c-.001 1.921 1.354 4.291 3.014 5.262l77.543 45.732c.829.486 1.921.728 3.012.724 1.092-.003 2.184-.231 3.011-.723l77.555-45.733c1.654-.981 3.005-3.338 3.003-5.262v-85.847l-51.027 29.727z"
  }));
};
Dpd.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "67.5",
  height: "30",
  viewBox: "79.5 293.5 448.931 206"
};
var Ups = function Ups(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M1.781 18.734l.222 25.168 5.654 6.985 16.964 8.98 20.844-10.2 4.324-10.311-.444-33.372-15.743-.444-16.41 2.66L2.226 16.85z",
    fillRule: "evenodd",
    fill: "#301506"
  }), __jsx("path", {
    d: "M26.069.547C16.188.547 7.569 2.46.45 6.232v30.16c0 6.346 2.384 11.653 6.894 15.35 4.188 3.435 17.138 9.096 18.725 9.783 1.505-.655 14.61-6.403 18.73-9.783 4.508-3.695 6.893-9.003 6.893-15.35V6.232C44.572 2.46 35.953.546 26.068.546zM40.7 6.387c2.947.038 5.84.22 8.637.48v29.525c0 5.674-2.06 10.257-6.032 13.529-3.548 2.923-14.25 7.717-17.236 9.033-3.026-1.334-13.754-6.189-17.239-9.032-3.948-3.216-6.027-7.908-6.027-13.529V19.141C14.151 8.734 27.931 6.221 40.699 6.387zM26.737 20.135c-2.431 0-4.393.543-6.008 1.585v29.05h4.46v-9.385c.444.13 1.09.254 2.005.254 4.946 0 7.79-4.46 7.79-10.97 0-6.497-2.928-10.534-8.247-10.534zm15.236 0c-2.933.085-6 2.209-5.98 5.81.007 2.371.664 4.145 4.34 6.3 1.96 1.152 2.75 1.91 2.785 3.31.037 1.554-1.037 2.492-2.672 2.486-1.423-.012-3.123-.801-4.262-1.815v4.104c1.396.832 3.138 1.383 4.898 1.383 4.405 0 6.372-3.112 6.457-5.963.084-2.6-.634-4.566-4.36-6.754-1.662-.975-2.974-1.616-2.93-3.239.043-1.583 1.358-2.14 2.62-2.128 1.558.013 3.065.876 3.995 1.83v-3.875c-.784-.604-2.444-1.525-4.891-1.45zm-36.893.45v14.013c0 4.724 2.234 7.115 6.644 7.115 2.73 0 5.015-.632 6.717-1.79V20.587h-4.449v16.8c-.485.333-1.204.546-2.11.546-2.042 0-2.347-1.873-2.347-3.137V20.586H5.08zm21.687 3.14c2.586 0 3.658 2.064 3.658 7.058 0 4.873-1.226 7.227-3.79 7.227-.605 0-1.13-.15-1.448-.27V24.047c.361-.18.975-.322 1.58-.322z",
    fill: "#fab80a"
  }));
};
Ups.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "30",
  viewBox: "0 0 52.242191 61.978519",
  width: "25"
};
var Geis = function Geis(props) {
  return __jsx("svg", props, __jsx("style", null, ".ge0", "{", "fill:#ed1d24", "}", ".ge1", "{", "fill:#fd0", "}", ".ge2", "{", "opacity:.3;fill:#fff", "}", ".ge3", "{", "opacity:.2", "}", ".ge4", "{", "fill:#044d7f", "}"), __jsx("path", {
    className: "ge0",
    d: "M53 533.3v-.2c0-14.6 11.4-26.6 27-26.6 9.3 0 14.9 2.5 20.2 7.1l-7.2 8.6c-4-3.3-7.5-5.2-13.5-5.2-8.2 0-14.8 7.3-14.8 16v.1c0 9.4 6.5 16.3 15.6 16.3 4.1 0 7.8-1 10.7-3.1v-7.4H79.7v-9.8H102v22.4c-5.3 4.5-12.6 8.2-22 8.2-16 .1-27-11.1-27-26.4m55.1 25.6h11.2v-53.7h-11.2v53.7zm15.3-19.5c0 11.3 9 20.4 21.3 20.4s21.4-9.2 21.4-20.5v-.1c0-11.3-9.1-20.4-21.3-20.4-12.3 0-21.4 9.2-21.4 20.5v.1m31.6 0c0 5.8-3.8 10.7-10.2 10.7-6.2 0-10.4-5.1-10.4-10.9v-.1c0-5.8 3.8-10.7 10.2-10.7 6.2 0 10.4 5.1 10.4 10.9v.1m25.5 14.4c2.6 3.2 6.3 5.9 12.3 5.9 9.4 0 17.9-7.2 17.9-20.4v-.2c0-13.1-8.8-20.4-17.9-20.4-5.8 0-9.6 2.7-12.3 6.4v-19.9h-11.2v53.7h11.2v-5.1m19-14.5c0 6.6-4.4 10.9-9.6 10.9-5.2 0-9.6-4.3-9.6-10.9v-.2c0-6.5 4.3-10.9 9.6-10.9 5.2 0 9.6 4.4 9.6 10.9v.2m13.4 8.2c0 7.8 6.1 12.1 13.5 12.1 5.5 0 9.2-2 11.9-5v4.3h10.8V536c0-5.3-1.3-9.6-4.3-12.6-2.8-2.8-7.2-4.4-13.3-4.4-6.7 0-10.9 1.2-15.3 3.2l2.8 8.5c3.6-1.3 6.6-2.1 10.9-2.1 5.6 0 8.5 2.6 8.5 7.2v.7c-2.8-1-5.7-1.6-9.6-1.6-9.3 0-15.9 4-15.9 12.6m25.7-2.5c0 4-3.5 6.9-8.8 6.9-3.6 0-6.1-1.8-6.1-4.8v-.2c0-3.5 3-5.4 7.7-5.4 2.7 0 5.2.6 7.1 1.5v2m16.6 13.9h11.2v-53.7h-11.2v53.7zm41.1.1h32.9v-10.3h-21.6v-41.2h-11.3V559zm34.2-19.6c0 11.3 9 20.4 21.3 20.4s21.4-9.2 21.4-20.5v-.1c0-11.3-9.1-20.4-21.3-20.4-12.3 0-21.4 9.2-21.4 20.5v.1m31.7 0c0 5.8-3.8 10.7-10.2 10.7-6.2 0-10.4-5.1-10.4-10.9v-.1c0-5.8 3.8-10.7 10.2-10.7 6.2 0 10.4 5.1 10.4 10.9v.1m16.4 27.3c5 2.6 11 4.1 17.4 4.1 7.6 0 13.3-1.6 17-5.3 3.3-3.3 5-8.5 5-15.5v-30.5h-11.2v5.1c-3-3.3-6.6-5.9-12.7-5.9-9 0-17.5 6.6-17.5 18.4v.2c0 11.7 8.3 18.4 17.5 18.4 6 0 9.6-2.4 12.9-6.4v1.9c0 7.1-3.6 10.7-11.3 10.7-5.2 0-9.3-1.3-13.3-3.6l-3.8 8.4m28.3-29.4c0 5.4-4.2 9.1-9.6 9.1-5.4 0-9.6-3.7-9.6-9.1v-.2c0-5.4 4.1-9.1 9.6-9.1 5.4 0 9.6 3.8 9.6 9.1v.2m18.4-23H437v-9.9h-11.8v9.9zm.3 44.6h11.2v-39.4h-11.2v39.4zm15.6-5.2c5.2 4.1 11.4 6 16.9 6 8.5 0 15.1-4 15.1-12.7v-.1c0-7.2-6.4-9.9-11.9-11.7-4.3-1.5-8-2.5-8-4.7v-.2c0-1.5 1.4-2.7 4.1-2.7 2.9 0 6.8 1.4 10.7 3.7l4.3-7.7c-4.3-2.9-9.7-4.6-14.7-4.6-8 0-14.4 4.5-14.4 12.5v.2c0 7.6 6.3 10.2 11.8 11.8 4.4 1.3 8.2 2.1 8.2 4.6v.1c0 1.8-1.5 3-4.7 3-3.7 0-8.2-1.6-12.4-4.7l-5 7.2m38.9-5.9c0 9.1 4.6 11.8 11.5 11.8 3.8 0 6.5-.9 8.8-2.3v-9c-1.6.9-3.5 1.4-5.5 1.4-2.5 0-3.6-1.2-3.6-3.8v-16.8h9.3v-9.6h-9.3v-10.1H480v10.1h-4.7v9.6h4.7v18.7m40.9-8.4c0 11.3 8.7 20.4 20.5 20.4 7.9 0 12.3-3 16.1-7.2L551 546c-2.7 2.6-5.3 4.2-9.1 4.2-6.1 0-10-4.9-10-10.9v-.1c0-5.8 4-10.7 9.6-10.7 4 0 6.5 1.7 9 4.4l6.8-7.4c-3.7-4.1-8.3-6.6-15.7-6.6-12.1 0-20.7 9.3-20.7 20.5m37.9 14.3c5.2 4.1 11.4 6 16.9 6 8.5 0 15.1-4 15.1-12.7v-.1c0-7.2-6.4-9.9-11.9-11.7-4.3-1.5-8-2.5-8-4.7v-.2c0-1.5 1.4-2.7 4.1-2.7 2.9 0 6.8 1.4 10.7 3.7l4.3-7.7c-4.3-2.9-9.7-4.6-14.7-4.6-8 0-14.4 4.5-14.4 12.5v.2c0 7.6 6.3 10.2 11.8 11.8 4.4 1.3 8.2 2.1 8.2 4.6v.1c0 1.8-1.5 3-4.7 3-3.7 0-8.2-1.6-12.4-4.7l-5 7.2m-52.6-39.4H518v-9.9h-11.8v9.9zm.3 44.6h11.2v-39.4h-11.2v39.4z"
  }), __jsx("path", {
    className: "ge1",
    d: "M182.5 114.1l72-43.2L543.9 143l-72.3 290.1-72 43.3-289.5-72.2z"
  }), __jsx("path", {
    className: "ge0",
    d: "M182.5 114.1L224.2 89l3.6 15.1-13.1 7.9 16 4 2.9 12.1-24.5 14.7-12.7-3.2-3.1 12.7-23.8 14.3 13-52.5zm57.8-34.7l3.6 15.1L261.3 84l21.4 5.3-2.9-12.1-25.3-6.3-14.2 8.5zm9.9 41.5l2.9 12.1-24.5 14.7 42.4 10.6 24.5-14.7-2.9-12.2-42.4-10.5zm48.5-39l2.8 12 42.4 10.7-2.8-12.1-42.4-10.6zm62.1 15.5l2.8 12 48.8 12.3-2.8-12.1-48.8-12.2zm68.1 17l2.9 12 45.7 11.5-2.8-12.1-45.8-11.4zM290 163.1l42.4 10.6 24.5-14.7-2.9-12.2-42.4-10.6 2.9 12.1-24.5 14.8zm62 15.5l48.8 12.2 24.4-14.8-2.9-12.1-48.7-12.1 2.9 12.1-24.5 14.7zm95 23.7l-6.5 26 24.5-14.7 10.3 13.1 6.6-26.5 14.7-8.8-9.5-12.1-3.9-16.5-19.2 11.5-22.4-5.6 2.9 12.2-24.5 14.7 27 6.7zm-21.7 87.4l24.5-14.7 10.3 13.1 10.3-41.2-10.4-13.1-24.5 14.7-10.2 41.2zm-15.5 62.1l24.5-14.7 10.4 13.1 10.4-41.8-10.4-13.1-24.5 14.7-10.4 41.8zm-15.5 62l24.5-14.7 10.4 13.1 10.4-41.8-10.4-13.1-24.5 14.7-10.4 41.8zm5.3 62.6l40.2-24.2-9.3-11.7-9.9 6 3.5-14.1-10.4-13.1-24.5 14.7-4.6 18.4-18.4-4.6-23.7 14.3 57.1 14.3zm-77.3-19.3l23.7-14.3-41.8-10.4-23.7 14.3 41.8 10.4zm-62.1-15.5l23.7-14.3-41.7-10.3-23.7 14.3 41.7 10.3zm-62-15.4l23.7-14.3-41.2-10.3-23.7 14.3 41.2 10.3zm-88.1-22l26.6 6.6 23.7-14.3-26.6-6.6 6.6-26.3-23.7 14.3-6.6 26.3zm35.1-59.9l12.2-48.8-23.7 14.3-12.2 48.8 23.7-14.3zm17.1-68.4l10.6-42.4-23.7 14.3-10.6 42.4 23.7-14.3zm15.3-61.4l10.6-42.4-23.7 14.3-10.6 42.4 23.7-14.3zm313.8-84.6l2.9 12.1 16.6 4.1-13.7 8.2 3.9 16.5 9.5 12 14-8.4-4.9 19.8 8.7 11 15.5-62.3-52.5-13zM503 261.3l8.7 11 11.8-47.4-8.7-11-11.8 47.4zm-15.4 61.5l8.7 11 10.3-41.2-8.7-11-10.3 41.2zm-15.4 62.1l8.7 11 10.4-41.8-8.7-11-10.4 41.8zm-18.1 58.7l17.5-10.5 4.2-17-8.7-11-3.9 15.8-18.3 11 9.2 11.7z"
  }), __jsx("path", {
    className: "ge2",
    d: "M182.5 114.1l289.1 74 72.3-45.1-289.5-72.1z"
  }), __jsx("path", {
    className: "ge3",
    d: "M543.9 143l-72.3 290.1-72 43.3 72-288.3z"
  }), __jsx("path", {
    className: "ge4",
    d: "M189.6 364.3c-14.3-23.1-8-55 19.6-72 14.5-9 28.7-9.6 37.6-6.3l-5.4 21.3c-6.9-1.6-14.7-1.2-22.5 3.6-14.6 9-17.6 26.5-9.4 39.8 6.3 10.1 16.9 10.9 25.8 5.4 4-2.5 6.6-5.2 8.4-7.9l-3.1-11.5-14.2 8.4-5-16.8 32.9-19.4 12.5 41.7c-4.6 8.6-11.9 17.4-22.6 24-17.2 10.8-40.8 11.9-54.6-10.3m112.6-44.2c-6.7 4.2-12.2 2.7-16.1-2.7l37.2-22.3c-.9-4.4-2.8-9.7-5.1-13.5-7.5-12.1-21.6-18.7-38.1-8.4-20.7 12.8-23 38-12.7 54.5 9.4 15.1 25.5 18.5 42 8.3 9.7-6 15-14 17.7-22.5l-15.7-5.1c-2.4 5.7-5.2 9.3-9.2 11.7m-21-14c-1.8-8.2 1.3-14.3 6.5-17.6 5.2-3.2 9.7-1.4 12.1 2.4.6 1 1.1 2.2 1.3 3.3l-19.9 11.9zm33.3-58l20.1-12-5.1-16.9-20.1 12.1 5.1 16.8zm21.3 71.2l20.2-12-19.5-64.7-20 12.1 19.3 64.6zm25.3-22.9c10.5 1 22.8-2.6 32.9-10 15.3-11.2 16.5-25.7 9-35.8-6.5-8.8-16.3-7.2-26.2-4.6-7.1 1.9-9.7 2.2-11 .4-1.4-1.9-.7-4.2 2.4-6.4 4.8-3.5 12-5.4 19.2-5.3l.7-17.7c-7.7-.4-18.8 2.3-28.4 9.4-14.6 10.7-17.1 25.2-9.3 35.8 6.2 8.4 15.4 7.4 26.3 4.6 6.7-1.8 9.6-2.2 10.9-.3 1.4 2 .8 4.4-2.3 6.7-5.4 4-14.4 6.7-22.9 5.8l-1.3 17.4"
  }));
};
Geis.defaultProps = {
  id: "layer",
  xmlns: "http://www.w3.org/2000/svg",
  width: "45",
  height: "45",
  viewBox: "0 0 652 652"
};
var GooglePay = function GooglePay(props) {
  return __jsx("svg", props, __jsx("path", {
    fill: "#fff",
    d: "M36.7.15H13.45a13.21 13.21 0 0 0 0 26.42H36.7a13.21 13.21 0 0 0 0-26.42z"
  }), __jsx("path", {
    fill: "#3c4043",
    d: "M36.7 1.22a12.11 12.11 0 0 1 8.57 3.57 11.92 11.92 0 0 1 2.61 3.86A12.15 12.15 0 0 1 36.7 25.5H13.45a12.15 12.15 0 0 1-8.57-3.57 12.36 12.36 0 0 1-2.61-3.86 12.15 12.15 0 0 1 0-9.42 12.36 12.36 0 0 1 2.61-3.86 12.15 12.15 0 0 1 8.57-3.57zm0-1.07H13.45a13.21 13.21 0 0 0 0 26.42H36.7a13.21 13.21 0 0 0 0-26.42z"
  }), __jsx("path", {
    fill: "#3c4043",
    d: "M23.92 14.3v4h-1.26V8.43H26a3 3 0 0 1 2.17.85 2.84 2.84 0 0 1 0 4.17 3 3 0 0 1-2.17.84h-2.1zm0-4.66v3.44H26a1.68 1.68 0 0 0 1.26-.51 1.67 1.67 0 0 0 0-2.4A1.65 1.65 0 0 0 26 9.65h-2.08zM32.42 11.32a3.14 3.14 0 0 1 2.22.75 2.67 2.67 0 0 1 .81 2.06v4.16h-1.21v-.94h-.05a2.4 2.4 0 0 1-2.1 1.16 2.71 2.71 0 0 1-1.86-.66 2.09 2.09 0 0 1-.76-1.65 2 2 0 0 1 .8-1.67 3.33 3.33 0 0 1 2.11-.62 3.64 3.64 0 0 1 1.85.42V14a1.43 1.43 0 0 0-.52-1.12 1.8 1.8 0 0 0-1.23-.47 1.93 1.93 0 0 0-1.67.9l-1.12-.7a3.11 3.11 0 0 1 2.73-1.29zm-1.64 4.9a1 1 0 0 0 .42.82 1.55 1.55 0 0 0 1 .33 2 2 0 0 0 1.42-.59 1.86 1.86 0 0 0 .63-1.39 2.61 2.61 0 0 0-1.65-.47 2.14 2.14 0 0 0-1.29.37 1.13 1.13 0 0 0-.53.93zM42.34 11.54l-4.22 9.72h-1.31l1.57-3.4-2.79-6.32H37l2 4.84 2-4.84z"
  }), __jsx("path", {
    fill: "#4285f4",
    d: "M18.88 13.49a7.64 7.64 0 0 0-.1-1.19h-5.32v2.18h3.06a2.6 2.6 0 0 1-1.13 1.76v1.41h1.82a5.54 5.54 0 0 0 1.67-4.16z"
  }), __jsx("path", {
    fill: "#34a853",
    d: "M15.39 16.24a3.43 3.43 0 0 1-1.93.54 3.37 3.37 0 0 1-3.17-2.34H8.41v1.46a5.65 5.65 0 0 0 5.05 3.1 5.39 5.39 0 0 0 3.75-1.37z"
  }), __jsx("path", {
    fill: "#fabb05",
    d: "M10.11 13.36a3.26 3.26 0 0 1 .18-1.08v-1.46H8.41a5.59 5.59 0 0 0-.6 2.54 5.53 5.53 0 0 0 .6 2.54l1.88-1.45a3.32 3.32 0 0 1-.18-1.09z"
  }), __jsx("path", {
    fill: "#e94235",
    d: "M13.46 10a3.06 3.06 0 0 1 2.17.84l1.62-1.61a5.45 5.45 0 0 0-3.79-1.47 5.64 5.64 0 0 0-5.05 3.11l1.88 1.46A3.37 3.37 0 0 1 13.46 10z"
  }));
};
GooglePay.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-1 -2 52 30"
};
var PayPo = function PayPo(props) {
  return __jsx("svg", props, __jsx("style", null, ".st0", "{", "fill:#a70584", "}", ".st1", "{", "fill:#36b588", "}", ".st2", "{", "fill:#fad05b", "}"), __jsx("path", {
    transform: "rotate(90 110.25 188.865)",
    className: "st0",
    d: "M80.5 158.9H140v60H80.5z"
  }), __jsx("path", {
    transform: "rotate(90 110.004 108.369)",
    className: "st1",
    d: "M80 78.4h60v60H80z"
  }), __jsx("path", {
    transform: "rotate(90 30.004 188.368)",
    className: "st2",
    d: "M0 158.4h60v60H0z"
  }), __jsx("path", {
    d: "M319.1 74.6c0 41.4-33.3 74.6-76.2 74.6h-32.7v68.4h-49.8V0h82.4c43 0 76.3 33.3 76.3 74.6zm-49.7 0c0-15.9-11.2-28-26.4-28h-32.7v56H243c15.2 0 26.4-12.1 26.4-28zM492.7 58v159.6h-47.9v-15c-10.5 12.1-26.2 19.5-47.6 19.5-41.8 0-76.3-36.7-76.3-84.3s34.5-84.3 76.3-84.3c21.4 0 37 7.3 47.6 19.5V58h47.9zm-47.9 79.8c0-23.9-16-39-38-39s-38 15-38 39c0 23.9 16 39 38 39 22-.1 38-15.1 38-39zM674.6 58l-54.2 153.8c-17.8 50.4-46 70.4-90.4 68.2v-44.4c22.2 0 32.7-7 39.6-26.3L506.6 58h52.3l35.2 97 29.8-97h50.7zM851.9 74.6c0 41.4-33.3 74.6-76.2 74.6H743v68.4h-49.8V0h82.4c43 0 76.3 33.3 76.3 74.6zm-49.7 0c0-15.9-11.2-28-26.4-28h-32.7v56h32.7c15.2 0 26.4-12.1 26.4-28zM858.1 140c0-46.3 36.7-82.1 82.4-82.1s82.4 35.8 82.4 82.1-36.7 82.1-82.4 82.1-82.4-35.8-82.4-82.1zm118.2 0c0-22.1-15.6-36.7-35.8-36.7-20.2 0-35.8 14.6-35.8 36.7s15.6 36.7 35.8 36.7c20.3 0 35.8-14.6 35.8-36.7z"
  }));
};
PayPo.defaultProps = {
  id: "Warstwa_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1023 280.1"
};
var Inpost24 = function Inpost24(props) {
  return __jsx("svg", props, __jsx("style", null, ".in24-0", "{", "fill:#ffcc08", "}", ".in24-2", "{", "fill:#404040", "}"), __jsx("path", {
    className: "in24-0",
    d: "M0 0h125.4v46.4H0z"
  }), __jsx("g", {
    fill: "#404040"
  }, __jsx("path", {
    d: "M38.9 37.4h-4.6V24.3c0-2.7-1.2-4.2-3.4-4.4-1.7 0-3.4.2-5.1.6v16.9h-4.5V17.2c3.5-.7 7-1.2 10.5-1.2 1.9 0 3.8.7 5.2 2.1 1.3 1.5 2 3.4 1.9 5.4v13.9zM115.4 37.5c-.7.2-1.5.3-2.3.3-1.9.3-3.8-.4-5.1-1.7-.8-1.6-1.1-3.3-1-5.1V10h4.5v6h4v3.7h-4v11.1c-.1.8.1 1.6.4 2.4.6.6 1.5.9 2.3.7h1.1l.1 3.6z",
    clipPath: "url(#SVGID_00000103976393701512787690000012087960669992978087_)"
  })), __jsx("path", {
    className: "in24-2",
    d: "M12.2 10h4.6v27.3h-4.6z"
  }), __jsx("g", {
    fill: "#404040"
  }, __jsx("path", {
    d: "M63.2 19.4c.1 2.5-.8 4.9-2.6 6.7-1.9 1.8-4.4 2.7-7 2.5H48v8.6h-4.6V9.9h9.9c2.7-.2 5.3.7 7.4 2.4 1.7 1.9 2.7 4.4 2.5 7.1m-4.6 0c.4-2.4-1.3-4.6-3.7-5-.4-.1-.8-.1-1.2 0H48v9.9h5.6c1.3.1 2.6-.4 3.6-1.3 1-1 1.4-2.3 1.4-3.6M84.6 26.6c.1 2.9-.9 5.7-2.8 7.9-3.9 4-10.2 4-14.2.1l-.1-.1c-1.9-2.2-2.9-5-2.8-7.9-.1-2.9.8-5.8 2.8-8 3.9-4 10.2-4 14.2-.1l.1.1c2 2.2 3 5 2.8 8m-4.6-.1c.1-1.7-.4-3.4-1.5-4.8-.9-1.2-2.3-1.8-3.8-1.8s-2.9.6-3.8 1.8c-1 1.4-1.5 3.1-1.4 4.9-.1 1.7.4 3.5 1.4 4.9.9 1.2 2.3 1.9 3.8 1.8 1.5 0 2.9-.6 3.8-1.8 1-1.5 1.6-3.2 1.5-5M104.3 30.3c.1 2-.8 3.9-2.4 5.1-1.8 1.4-4 2.1-6.2 2-3.5.2-7-1.1-9.5-3.7l3.3-2.7c1.6 1.6 3.7 2.5 6 2.5 1.1.1 2.2-.2 3.1-.7.7-.4 1.1-1.1 1.1-1.9 0-.8-.5-1.6-1.3-1.8-1.3-.3-2.6-.6-4-.8-2-.2-3.9-.7-5.6-1.7-1.3-1-2-2.5-1.9-4.2 0-1.9.9-3.6 2.4-4.7 1.8-1.3 4-2 6.2-1.9 3-.1 5.9 1 8.1 3.1l-2.6 2.8c-1.5-1.4-3.5-2.1-5.6-2.1-2.7 0-4 .7-4 2.2 0 .9.6 1.5 1.8 1.8 1.2.3 3.4.6 5.1.8 4.1.8 6 2.7 6 5.9",
    clipPath: "url(#SVGID_00000096059424765599436540000003102948320693915563_)"
  })), __jsx("path", {
    className: "in24-2",
    d: "M125.4 0h322.9v46.4H125.4z"
  }), __jsx("path", {
    d: "M415.2 10v8.4h4.5V14h10.1l-9.7 21.8h5.1l10-22.6V10h-20zM399 39.5h4.1l12.2-34.7h-4.1L399 39.5zm-.2-13.6h-4.6v-5.2h-4.5v5.2h-8.4l12-15.9h-5.1l-12.7 16.6V30h14.2v5.9h4.6V30h4.6v-4.1zm-37.4 5.9l6.9-6.6c1.7-1.6 2.8-3 3.4-4.2.6-1.2.9-2.5.9-3.9 0-2.3-.8-4.1-2.5-5.4-1.7-1.3-3.9-2-6.7-2-2.1 0-4 .4-5.7 1.1-1.7.7-3.1 1.8-4.1 3.2l3.4 2.6c1.4-1.8 3.4-2.7 6-2.7 1.6 0 2.8.3 3.6 1 .8.6 1.2 1.6 1.2 2.8 0 .8-.2 1.6-.6 2.5-.4.8-1.2 1.8-2.3 2.9l-10.2 9.7V36h19v-4.1h-12.3zm-16.3-.3c-.7.5-1.5.8-2.6.8-.9 0-1.6-.3-2-.8-.5-.5-.7-1.2-.7-2.2V20h5.3v-3.7h-5.3v-4.5h-4.6v4.5H332V20h3.2v9.5c0 2.2.6 3.8 1.8 4.9 1.2 1.1 2.9 1.7 5 1.7.9 0 1.7-.1 2.5-.3.8-.2 1.4-.6 2-1l-1.4-3.3zm-26 1.2c-1.2 0-2.1-.2-2.8-.7-.7-.5-1-1.2-1-2 0-1.7 1.3-2.6 4-2.6h4.8v2.3c-.4 1-1 1.7-1.9 2.3-.9.5-2 .7-3.1.7m.6-16.8c-1.6 0-3.2.2-4.6.6s-2.7 1-3.7 1.8l1.8 3.4c.7-.6 1.6-1.1 2.7-1.4 1.1-.3 2.2-.5 3.3-.5 1.6 0 2.8.4 3.7 1.1.8.7 1.2 1.8 1.2 3.2v.3H319c-2.8 0-4.9.5-6.2 1.6-1.3 1.1-2 2.5-2 4.3 0 1.1.3 2.1.9 3 .6.9 1.5 1.6 2.6 2.1s2.4.8 3.9.8 2.7-.2 3.8-.7 1.8-1.1 2.4-2v2.4h4.4V24.3c0-2.8-.8-4.9-2.3-6.3-1.7-1.4-3.9-2.1-6.8-2.1m-21.5 0c-1.5 0-3 .3-4.2.9-1.3.6-2.3 1.4-3.1 2.4-.7-1.1-1.6-1.9-2.7-2.5-1.1-.6-2.5-.8-3.9-.8s-2.6.2-3.7.7c-1.1.5-2 1.1-2.8 2v-2.5h-4.4v19.7h4.6v-10c0-1.9.5-3.4 1.4-4.4.9-1 2.2-1.5 3.7-1.5 1.4 0 2.5.4 3.3 1.3.8.9 1.1 2.2 1.1 3.9v10.7h4.6v-10c0-1.9.5-3.3 1.4-4.4.9-1 2.2-1.5 3.7-1.5 1.4 0 2.5.4 3.3 1.3.8.9 1.1 2.2 1.1 3.9v10.7h4.6V24.6c0-2.9-.7-5-2.2-6.5-1.3-1.5-3.3-2.2-5.8-2.2m-39.8 16.2c-1.7 0-3.1-.6-4.2-1.7s-1.6-2.6-1.6-4.5c0-1.8.5-3.3 1.6-4.5 1.1-1.1 2.5-1.7 4.2-1.7 1.7 0 3.1.6 4.2 1.7s1.7 2.6 1.7 4.5c0 1.8-.6 3.3-1.7 4.5-1.1 1.2-2.5 1.7-4.2 1.7m0 4c2 0 3.8-.4 5.4-1.3 1.6-.9 2.8-2.1 3.7-3.6.9-1.5 1.3-3.3 1.3-5.2 0-1.9-.4-3.7-1.3-5.2s-2.1-2.7-3.7-3.6c-1.6-.9-3.4-1.3-5.4-1.3-2 0-3.8.4-5.4 1.3-1.6.9-2.8 2.1-3.7 3.6-.9 1.5-1.3 3.3-1.3 5.2 0 1.9.4 3.7 1.3 5.2s2.1 2.7 3.7 3.6c1.7.9 3.5 1.3 5.4 1.3m-16.6-.3h5.6l-9-11.4 8.2-8.3h-5.5l-9.5 8.8V8.5H227v27.4h4.6v-5.2l3.4-3.2 6.8 8.3zm-30.2-3.7L222.4 19v-2.9H206v3.7h10.6l-10.8 13.1v2.9h17v-3.7h-11.2zm-16.5 4c1.9 0 3.6-.4 5.1-1.2 1.5-.8 2.6-1.9 3.3-3.4l-3.5-2.1c-.6.9-1.3 1.6-2.1 2-.8.5-1.8.7-2.8.7-1.7 0-3.2-.6-4.3-1.7-1.1-1.1-1.7-2.6-1.7-4.5s.6-3.4 1.7-4.5 2.6-1.7 4.3-1.7c1 0 1.9.2 2.8.7.8.5 1.6 1.1 2.1 2l3.5-2.1c-.7-1.5-1.8-2.6-3.3-3.4-1.5-.8-3.2-1.2-5.1-1.2-2.1 0-3.9.4-5.5 1.3s-2.9 2.1-3.8 3.6c-.9 1.5-1.4 3.3-1.4 5.2 0 1.9.5 3.7 1.4 5.2.9 1.5 2.2 2.7 3.8 3.6 1.7 1.1 3.5 1.5 5.5 1.5m-24.7-3.4c-1.2 0-2.1-.2-2.8-.7-.7-.5-1-1.2-1-2 0-1.7 1.3-2.6 4-2.6h4.8v2.3c-.4 1-1 1.7-1.9 2.3-.9.5-1.9.7-3.1.7m.7-16.8c-1.6 0-3.2.2-4.6.6-1.4.4-2.7 1-3.7 1.8l1.8 3.4c.7-.6 1.6-1.1 2.7-1.4 1.1-.3 2.2-.5 3.3-.5 1.6 0 2.8.4 3.7 1.1.8.7 1.2 1.8 1.2 3.2v.3h-5.1c-2.8 0-4.9.5-6.2 1.6-1.3 1.1-2 2.5-2 4.3 0 1.1.3 2.1.9 3 .6.9 1.5 1.6 2.6 2.1s2.4.8 3.9.8 2.7-.2 3.8-.7c1-.5 1.8-1.1 2.4-2v2.4h4.3V24.3c0-2.8-.8-4.9-2.3-6.3-1.6-1.4-3.8-2.1-6.7-2.1m-22.9 8.4h-5.6V14.1h5.6c2.1 0 3.7.4 4.8 1.3 1.1.9 1.6 2.2 1.6 3.8 0 1.6-.5 2.9-1.6 3.8-1.1.9-2.7 1.3-4.8 1.3m.2-14.3h-10.6v25.8h4.8v-7.4h5.8c2.2 0 4.2-.4 5.8-1.1 1.7-.7 2.9-1.8 3.8-3.2.9-1.4 1.3-3 1.3-4.9 0-1.9-.4-3.5-1.3-4.9-.9-1.4-2.2-2.4-3.8-3.2-1.6-.7-3.6-1.1-5.8-1.1",
    clipPath: "url(#SVGID_00000072275071687395393690000001979992594327946403_)",
    fill: "#fff"
  }));
};
Inpost24.defaultProps = {
  id: "Warstwa_1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "194",
  height: "30",
  viewBox: "0 0 448.4 46.4"
};
var Card = function Card(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M29.94 21.81H2.75a2.51 2.51 0 0 1-2.56-2.49V2.77A2.52 2.52 0 0 1 2.75.28h27.19a2.53 2.53 0 0 1 2.56 2.49v16.55a2.53 2.53 0 0 1-2.56 2.49z"
  }), __jsx("path", {
    fill: "#fff",
    d: "M29.13 16.43h-5.38a.67.67 0 0 0-.68.67v1.35a.67.67 0 0 0 .68.67h5.38a.67.67 0 0 0 .67-.67V17.1a.67.67 0 0 0-.67-.67zM.19 9.7H32.5v-4H.19z"
  }));
};
Card.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32.71 22.16"
};
var Klarna = function Klarna(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#clip0_8313_28082)"
  }, __jsx("path", {
    d: "M40.679 0H4.321A4.321 4.321 0 0 0 0 4.321v16.358A4.321 4.321 0 0 0 4.321 25h36.358A4.321 4.321 0 0 0 45 20.679V4.321A4.321 4.321 0 0 0 40.679 0z",
    fill: "#FFB3C7"
  }), __jsx("path", {
    d: "M40.794 14.646a1.07 1.07 0 0 0-1.066 1.076c0 .594.477 1.076 1.066 1.076.589 0 1.066-.482 1.066-1.076a1.07 1.07 0 0 0-1.066-1.076zm-3.508-.831c0-.814-.689-1.473-1.538-1.473-.85 0-1.54.66-1.54 1.473 0 .813.69 1.473 1.54 1.473.85 0 1.538-.66 1.538-1.473zm.006-2.862h1.698v5.724h-1.698v-.366c-.48.33-1.059.524-1.684.524-1.653 0-2.993-1.352-2.993-3.02s1.34-3.02 2.993-3.02c.625 0 1.204.193 1.684.524v-.367zm-13.592.745v-.745h-1.739v5.724h1.743v-2.673c0-.901.968-1.386 1.64-1.386h.02v-1.665c-.689 0-1.323.298-1.664.745zm-4.331 2.117c0-.814-.69-1.473-1.54-1.473-.85 0-1.538.66-1.538 1.473 0 .813.689 1.473 1.538 1.473.85 0 1.54-.66 1.54-1.473zm.005-2.862h1.699v5.724h-1.699v-.366a2.96 2.96 0 0 1-1.683.524c-1.654 0-2.994-1.352-2.994-3.02s1.34-3.02 2.994-3.02c.624 0 1.203.193 1.683.524v-.366zm10.223-.154c-.678 0-1.32.212-1.75.799v-.645h-1.69v5.724h1.711v-3.008c0-.87.579-1.297 1.275-1.297.747 0 1.176.45 1.176 1.285v3.02h1.696v-3.64c0-1.332-1.05-2.238-2.418-2.238zm-17.374 5.878h1.778V8.402h-1.778v8.275zm-7.809.002h1.882V8.4H4.414v8.28zM10.998 8.4c0 1.793-.692 3.46-1.926 4.7l2.603 3.58H9.348l-2.827-3.892.73-.551A4.768 4.768 0 0 0 9.155 8.4h1.842z",
    fill: "#0A0B09"
  })));
};
Klarna.defaultProps = {
  viewBox: "-1 -1 47 27",
  xmlns: "http://www.w3.org/2000/svg"
};
var ApplePay = function ApplePay(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#a)"
  }, __jsx("path", {
    d: "M36.976 0H3.22c-.118.002-.235.003-.351.006a5.1 5.1 0 0 0-.764.067 2.579 2.579 0 0 0-.726.24A2.437 2.437 0 0 0 .312 1.38c-.118.232-.193.47-.239.726-.045.252-.06.51-.067.764-.003.117-.005.234-.005.35L0 3.637V22.78c.001.117.003.234.006.35.007.255.022.512.067.764.046.256.121.494.24.726a2.428 2.428 0 0 0 1.067 1.067c.232.119.47.194.726.24.252.045.509.06.764.067.116.003.233.004.35.005l.417.001h33.339l.416-.001c.117 0 .234-.002.351-.005.255-.007.512-.022.764-.067.256-.046.494-.121.726-.24A2.425 2.425 0 0 0 40.3 24.62c.119-.232.194-.47.24-.726.045-.252.06-.51.066-.763.004-.117.005-.234.006-.351V3.637 3.22c0-.116-.002-.233-.006-.35a5.067 5.067 0 0 0-.067-.764A2.448 2.448 0 0 0 38.507.073a5.115 5.115 0 0 0-.764-.067 17.517 17.517 0 0 0-.35-.005L36.975 0z",
    fill: "#000"
  }), __jsx("path", {
    d: "M36.976.867h.41c.112.001.223.002.334.006.195.005.422.015.634.053.184.033.339.084.487.16a1.566 1.566 0 0 1 .688.688c.075.147.125.3.158.486.038.21.048.438.054.634a56.031 56.031 0 0 1 .006.744v18.725l-.001.413c0 .11-.002.22-.005.331a4.297 4.297 0 0 1-.054.635 1.68 1.68 0 0 1-.158.485 1.566 1.566 0 0 1-.69.689 1.698 1.698 0 0 1-.483.158c-.217.038-.453.049-.632.054-.112.002-.224.004-.338.004-.136.002-.273.001-.41.001H3.225l-.331-.005a4.41 4.41 0 0 1-.634-.054 1.706 1.706 0 0 1-.488-.16 1.555 1.555 0 0 1-.687-.687 1.701 1.701 0 0 1-.158-.487 4.286 4.286 0 0 1-.054-.633 16.216 16.216 0 0 1-.005-.332V3.226c0-.11.002-.222.005-.333a4.29 4.29 0 0 1 .054-.634c.033-.184.083-.338.159-.486a1.564 1.564 0 0 1 .688-.688c.147-.075.302-.126.486-.159.212-.038.439-.048.634-.054.11-.003.222-.004.332-.004l.412-.001h33.338z",
    fill: "#fff"
  }), __jsx("path", {
    d: "M11.085 8.745c.348-.435.584-1.02.521-1.616-.509.025-1.13.336-1.49.771-.322.373-.608.981-.534 1.553.572.05 1.143-.285 1.503-.708zM11.601 9.565c-.83-.05-1.535.47-1.932.47-.396 0-1.003-.445-1.66-.433-.854.012-1.646.495-2.08 1.264-.892 1.536-.235 3.816.632 5.068.421.62.929 1.3 1.597 1.276.632-.024.88-.409 1.648-.409.767 0 .99.41 1.659.397.693-.012 1.127-.62 1.548-1.24.483-.705.68-1.387.693-1.424-.012-.013-1.337-.521-1.35-2.045-.012-1.276 1.04-1.883 1.09-1.92-.594-.88-1.523-.98-1.845-1.004zM18.825 7.838c1.804 0 3.06 1.243 3.06 3.053 0 1.817-1.282 3.067-3.105 3.067h-1.997v3.175H15.34V7.838h3.485zm-2.042 4.908h1.655c1.256 0 1.971-.676 1.971-1.848 0-1.173-.715-1.843-1.964-1.843h-1.662v3.691zM22.262 15.207c0-1.185.908-1.913 2.519-2.003l1.855-.11v-.521c0-.754-.51-1.205-1.36-1.205-.805 0-1.307.386-1.43.992h-1.314c.078-1.224 1.121-2.126 2.796-2.126 1.643 0 2.693.87 2.693 2.229v4.67h-1.334V16.02h-.032c-.393.754-1.25 1.23-2.139 1.23-1.327 0-2.254-.824-2.254-2.042zm4.374-.612v-.534l-1.669.103c-.83.058-1.301.425-1.301 1.005 0 .592.49.979 1.237.979.973 0 1.733-.67 1.733-1.553zM29.28 19.627v-1.128c.102.026.334.026.45.026.644 0 .992-.27 1.205-.966 0-.013.122-.413.122-.42l-2.448-6.782h1.508l1.713 5.514h.026l1.714-5.514h1.468l-2.538 7.13c-.58 1.644-1.25 2.172-2.654 2.172-.116 0-.464-.013-.567-.032z",
    fill: "#000"
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "a"
  }, __jsx("path", {
    fill: "#fff",
    d: "M0 0h40.613v26H0z"
  }))));
};
ApplePay.defaultProps = {
  viewBox: "-2 -2 44 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BankTransfer = function BankTransfer(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#clip0_8313_28098)",
    fill: "#1C1C1C"
  }, __jsx("path", {
    d: "M30.817 23.881a.688.688 0 0 0-.686-.686h-.967v-6.867h.144a2.212 2.212 0 0 0 2.21-2.21v-1.056c0-1.22-.989-2.209-2.21-2.209h-2.744l-5.516-5.145a.689.689 0 0 0-.94 0l-5.495 5.145H11.87a2.212 2.212 0 0 0-2.209 2.21v1.056c0 1.22.995 2.209 2.21 2.209h.143v6.867h-.967a.688.688 0 0 0-.686.686c0 .377.309.686.686.686h19.072a.688.688 0 0 0 .686-.686h.014zm-3.025-.686H25.22v-6.867h2.573v6.867zm-7.882-6.867v6.867h-2.573v-6.867h2.573zm1.372 0h2.572v6.867h-2.572v-6.867zm-.693-9.186l3.972 3.704h-7.93l3.958-3.704zm-9.55 6.977v-1.057a.84.84 0 0 1 .837-.837h17.44a.84.84 0 0 1 .836.837v1.057a.84.84 0 0 1-.837.837H11.876a.84.84 0 0 1-.837-.837zm2.36 2.209h2.573v6.867h-2.573v-6.867z"
  }), __jsx("path", {
    d: "M40.992 26.42l-6.34-6.415a.675.675 0 0 0-.747-.151.677.677 0 0 0-.426.631v2.724h-1.152a.688.688 0 0 0-.686.686c0 .377.309.686.686.686h1.838a.688.688 0 0 0 .686-.686v-1.743l4.686 4.747-4.686 4.748v-1.743a.688.688 0 0 0-.686-.686h-11.21a.688.688 0 0 0-.685.686c0 .378.308.686.686.686h10.523v2.73a.68.68 0 0 0 .426.632.67.67 0 0 0 .748-.15l6.339-6.415c.26-.268.26-.7 0-.968zM8.857 9.42H7.02a.688.688 0 0 0-.686.687v1.742L1.647 7.102l4.686-4.747v1.742c0 .378.308.686.686.686h11.21a.688.688 0 0 0 .686-.686.688.688 0 0 0-.686-.686H7.705V.688a.685.685 0 1 0-1.173-.48L.199 6.621c-.26.267-.26.7 0 .967l6.34 6.415a.698.698 0 0 0 .747.157.68.68 0 0 0 .426-.638V10.8h1.152a.688.688 0 0 0 .686-.686.688.688 0 0 0-.686-.686l-.007-.007z"
  })));
};
BankTransfer.defaultProps = {
  viewBox: "-2 -1 45 36",
  xmlns: "http://www.w3.org/2000/svg"
};
var CashOnDelivery = function CashOnDelivery(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#clip0_8313_28091)",
    fill: "#1C1C1C"
  }, __jsx("path", {
    d: "M33.486 23.62l-.724-.489a.642.642 0 0 0-.838.108l-.451.521-.636-.356c-.247-.8-1.143-2.947-3.773-3.335-1.836-.267-4.867.921-4.994.972l-4.663 1.849a2.014 2.014 0 0 0-1.112 1.08 2.002 2.002 0 0 0-.025 1.544c.019.05.05.095.076.14l-3.805.298-1.976-2.56a2.219 2.219 0 0 0-3.1-.394 2.213 2.213 0 0 0-.4 3.1l2.522 3.265s.019.026.031.039c.33.482.826.813 1.385.927l6.912 1.55c.058.02.115.032.16.038l.107.026a2.22 2.22 0 0 0 .845.006c.26-.032.496-.089.712-.178l5.146-2.045 1.003.463-.101.115a.625.625 0 0 0-.146.502c.025.184.12.343.273.444l.857.578a.635.635 0 0 0 .712-1.055l-.267-.177 5.28-6.112.26.178a.635.635 0 1 0 .712-1.055l.018.013zm-8.303 4.848a.626.626 0 0 0-.502-.013l-5.393 2.14a2.204 2.204 0 0 1-.458.109.9.9 0 0 1-.368 0l-.115-.026-.114-.025-6.957-1.563a.976.976 0 0 1-.616-.419c-.019-.025-.038-.05-.063-.076l-2.529-3.272a.935.935 0 0 1 .172-1.315.94.94 0 0 1 1.315.165L11.74 27c.134.172.337.26.553.248l5.851-.457h.013l.305-.026s.019 0 .025-.006c.14-.026.273-.058.407-.108l4.409-1.747a.64.64 0 0 0 .355-.826.64.64 0 0 0-.825-.356l-4.41 1.747a.864.864 0 0 1-.253.05h-.045a.73.73 0 0 1-.673-.47.752.752 0 0 1 .419-.971l4.663-1.849c.788-.311 3.094-1.08 4.34-.896 2.28.337 2.769 2.535 2.788 2.624a.659.659 0 0 0 .311.432l.642.356-3.85 4.453-1.588-.73h.006z"
  }), __jsx("path", {
    d: "M8.254 20.596c.42-.47.814-.864 1.182-1.213l.12.464a2.317 2.317 0 0 0 2.828 1.645 2.28 2.28 0 0 0 1.43-1.13 2.307 2.307 0 0 0 1.803.273 2.3 2.3 0 0 0 1.284-.903c.406.337.927.54 1.474.54a2.3 2.3 0 0 0 2.243-2.82h12.356c.35 0 .635-.286.635-.636V.636A.637.637 0 0 0 32.974 0H8.165a.637.637 0 0 0-.635.635v6.353L5.548 6.57a.62.62 0 0 0-.52.12L.44 10.217a.63.63 0 0 0-.114.889.625.625 0 0 0 .502.248.637.637 0 0 0 .387-.134l4.358-3.354 1.957.413v5.578c-2.02.877-3.64.737-3.66.737a.635.635 0 1 0-.133 1.264c.134.013 3.266.318 6.487-2.11 1.207-.908 2.293-1.308 3.043-1.13.495.12.73.464.826.654.362.731-.394 1.754-1.976 2.675-.083.045-.178.095-.292.159-.813.42-2.319 1.2-4.51 3.634C5.04 22.267 2.415 22.87.617 22.928a.632.632 0 0 0-.61.654.638.638 0 0 0 .636.616h.025c2.046-.07 5.019-.75 7.598-3.608l-.013.006zm3.8-.336a1.038 1.038 0 0 1-1.271-.737l-.28-1.068a10.862 10.862 0 0 1 1.512-1.003h.369l.406 1.543s.007.026.013.032a1.036 1.036 0 0 1-.743 1.233h-.007zm3.227-.852a1.038 1.038 0 0 1-1.258-.705v-.032l-.324-1.22h2.14l.185.706a1.04 1.04 0 0 1-.737 1.258l-.006-.007zm4.085-1.709a1.038 1.038 0 1 1-2.008.534l-.101-.394v-.019l-.096-.362h2.148l.063.248-.006-.007zm-5.807-6.308c-.476-.114-.99-.095-1.544.038V6.804a3.284 3.284 0 0 0 2.96-2.929h2.307c-1.283 1.118-2.116 2.878-2.116 4.854s.833 3.73 2.116 4.847H15.44a2.194 2.194 0 0 0-.21-.857 2.472 2.472 0 0 0-1.67-1.328zm11.188 2.185h-.909c1.284-1.118 2.116-2.878 2.116-4.847 0-1.97-.832-3.73-2.116-4.854h2.313a3.284 3.284 0 0 0 2.96 2.929v3.844a3.278 3.278 0 0 0-2.96 2.928h-1.404zm-.07-4.847c0 2.675-1.849 4.847-4.117 4.847s-4.117-2.172-4.117-4.847c0-2.675 1.85-4.854 4.117-4.854 2.268 0 4.117 2.18 4.117 4.854zm-9.549 6.118h11.658a.635.635 0 0 0 .635-.705l-.012-.102c0-.044-.013-.089-.013-.14a2 2 0 0 1 2.001-2c.083 0 .165.005.248.018a.664.664 0 0 0 .508-.146.636.636 0 0 0 .216-.483V6.137a.623.623 0 0 0-.216-.476.63.63 0 0 0-.502-.153l-.076.013c-.057.006-.12.019-.178.019a2 2 0 0 1-2.001-2.001c0-.083.006-.16.019-.235a.643.643 0 0 0-.159-.496.64.64 0 0 0-.476-.21H14.334a.636.636 0 0 0-.629.7c.007.075.02.158.02.24a2 2 0 0 1-2.002 2.002c-.063 0-.12-.013-.178-.02l-.076-.012a.636.636 0 0 0-.718.629v5.775c-.413.216-.845.489-1.29.82-.222.165-.444.31-.66.45V1.271h23.531v14.91H14.017c.552-.47.908-.921 1.124-1.334h-.013z"
  })));
};
CashOnDelivery.defaultProps = {
  viewBox: "-2 -2 38 35",
  xmlns: "http://www.w3.org/2000/svg"
};
var GooglePayDisabled = function GooglePayDisabled(props) {
  return __jsx("svg", props, __jsx("path", {
    fill: "#fff",
    d: "M36.7.15H13.45a13.21 13.21 0 0 0 0 26.42H36.7a13.21 13.21 0 0 0 0-26.42z"
  }), __jsx("path", {
    fill: "#b2b2b2",
    d: "M36.7 1.22a12.11 12.11 0 0 1 8.57 3.57 11.92 11.92 0 0 1 2.61 3.86A12.15 12.15 0 0 1 36.7 25.5H13.45a12.15 12.15 0 0 1-8.57-3.57 12.36 12.36 0 0 1-2.61-3.86 12.15 12.15 0 0 1 0-9.42 12.36 12.36 0 0 1 2.61-3.86 12.15 12.15 0 0 1 8.57-3.57zm0-1.07H13.45a13.21 13.21 0 0 0 0 26.42H36.7a13.21 13.21 0 0 0 0-26.42z"
  }), __jsx("path", {
    fill: "#b2b2b2",
    d: "M23.92 14.3v4h-1.26V8.43H26a3 3 0 0 1 2.17.85 2.84 2.84 0 0 1 0 4.17 3 3 0 0 1-2.17.84h-2.1zm0-4.66v3.44H26a1.68 1.68 0 0 0 1.26-.51 1.67 1.67 0 0 0 0-2.4A1.65 1.65 0 0 0 26 9.65h-2.08zM32.42 11.32a3.14 3.14 0 0 1 2.22.75 2.67 2.67 0 0 1 .81 2.06v4.16h-1.21v-.94h-.05a2.4 2.4 0 0 1-2.1 1.16 2.71 2.71 0 0 1-1.86-.66 2.09 2.09 0 0 1-.76-1.65 2 2 0 0 1 .8-1.67 3.33 3.33 0 0 1 2.11-.62 3.64 3.64 0 0 1 1.85.42V14a1.43 1.43 0 0 0-.52-1.12 1.8 1.8 0 0 0-1.23-.47 1.93 1.93 0 0 0-1.67.9l-1.12-.7a3.11 3.11 0 0 1 2.73-1.29zm-1.64 4.9a1 1 0 0 0 .42.82 1.55 1.55 0 0 0 1 .33 2 2 0 0 0 1.42-.59 1.86 1.86 0 0 0 .63-1.39 2.61 2.61 0 0 0-1.65-.47 2.14 2.14 0 0 0-1.29.37 1.13 1.13 0 0 0-.53.93zM42.34 11.54l-4.22 9.72h-1.31l1.57-3.4-2.79-6.32H37l2 4.84 2-4.84z"
  }), __jsx("path", {
    fill: "#cbcbcb",
    d: "M18.88 13.49a7.64 7.64 0 0 0-.1-1.19h-5.32v2.18h3.06a2.6 2.6 0 0 1-1.13 1.76v1.41h1.82a5.54 5.54 0 0 0 1.67-4.16z"
  }), __jsx("path", {
    fill: "#cbcbcb",
    d: "M15.39 16.24a3.43 3.43 0 0 1-1.93.54 3.37 3.37 0 0 1-3.17-2.34H8.41v1.46a5.65 5.65 0 0 0 5.05 3.1 5.39 5.39 0 0 0 3.75-1.37z"
  }), __jsx("path", {
    fill: "#e3e3e3",
    d: "M10.11 13.36a3.26 3.26 0 0 1 .18-1.08v-1.46H8.41a5.59 5.59 0 0 0-.6 2.54 5.53 5.53 0 0 0 .6 2.54l1.88-1.45a3.32 3.32 0 0 1-.18-1.09z"
  }), __jsx("path", {
    fill: "#cbcbcb",
    d: "M13.46 10a3.06 3.06 0 0 1 2.17.84l1.62-1.61a5.45 5.45 0 0 0-3.79-1.47 5.64 5.64 0 0 0-5.05 3.11l1.88 1.46A3.37 3.37 0 0 1 13.46 10z"
  }));
};
GooglePayDisabled.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-1 -2 52 30"
};
var CardDisabled = function CardDisabled(props) {
  return __jsx("svg", props, __jsx("g", {
    className: "cls-2"
  }, __jsx("path", {
    fill: "#999",
    d: "M29.94 21.81H2.75a2.51 2.51 0 0 1-2.56-2.49V2.77A2.52 2.52 0 0 1 2.75.28h27.19a2.53 2.53 0 0 1 2.56 2.49v16.55a2.53 2.53 0 0 1-2.56 2.49z"
  }), __jsx("path", {
    fill: "#fff",
    d: "M29.13 16.43h-5.38a.67.67 0 0 0-.68.67v1.35a.67.67 0 0 0 .68.67h5.38a.67.67 0 0 0 .67-.67V17.1a.67.67 0 0 0-.67-.67zM.19 9.7H32.5v-4H.19z"
  })));
};
CardDisabled.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32.71 22.16"
};
var KlarnaDisabled = function KlarnaDisabled(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#clip0_8313_28082)"
  }, __jsx("path", {
    d: "M40.679 0H4.321A4.321 4.321 0 0 0 0 4.321v16.358A4.321 4.321 0 0 0 4.321 25h36.358A4.321 4.321 0 0 0 45 20.679V4.321A4.321 4.321 0 0 0 40.679 0z",
    fill: "#ebebeb"
  }), __jsx("path", {
    d: "M40.794 14.646a1.07 1.07 0 0 0-1.066 1.076c0 .594.477 1.076 1.066 1.076.589 0 1.066-.482 1.066-1.076a1.07 1.07 0 0 0-1.066-1.076zm-3.508-.831c0-.814-.689-1.473-1.538-1.473-.85 0-1.54.66-1.54 1.473 0 .813.69 1.473 1.54 1.473.85 0 1.538-.66 1.538-1.473zm.006-2.862h1.698v5.724h-1.698v-.366c-.48.33-1.059.524-1.684.524-1.653 0-2.993-1.352-2.993-3.02s1.34-3.02 2.993-3.02c.625 0 1.204.193 1.684.524v-.367zm-13.592.745v-.745h-1.739v5.724h1.743v-2.673c0-.901.968-1.386 1.64-1.386h.02v-1.665c-.689 0-1.323.298-1.664.745zm-4.331 2.117c0-.814-.69-1.473-1.54-1.473-.85 0-1.538.66-1.538 1.473 0 .813.689 1.473 1.538 1.473.85 0 1.54-.66 1.54-1.473zm.005-2.862h1.699v5.724h-1.699v-.366a2.96 2.96 0 0 1-1.683.524c-1.654 0-2.994-1.352-2.994-3.02s1.34-3.02 2.994-3.02c.624 0 1.203.193 1.683.524v-.366zm10.223-.154c-.678 0-1.32.212-1.75.799v-.645h-1.69v5.724h1.711v-3.008c0-.87.579-1.297 1.275-1.297.747 0 1.176.45 1.176 1.285v3.02h1.696v-3.64c0-1.332-1.05-2.238-2.418-2.238zm-17.374 5.878h1.778V8.402h-1.778v8.275zm-7.809.002h1.882V8.4H4.414v8.28zM10.998 8.4c0 1.793-.692 3.46-1.926 4.7l2.603 3.58H9.348l-2.827-3.892.73-.551A4.768 4.768 0 0 0 9.155 8.4h1.842z",
    fill: "#9d9d9d"
  })));
};
KlarnaDisabled.defaultProps = {
  viewBox: "-1 -1 47 27",
  xmlns: "http://www.w3.org/2000/svg"
};
var ApplePayDisabled = function ApplePayDisabled(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#a)"
  }, __jsx("path", {
    d: "M36.976 0H3.22c-.118.002-.235.003-.351.006a5.1 5.1 0 0 0-.764.067 2.579 2.579 0 0 0-.726.24A2.437 2.437 0 0 0 .312 1.38c-.118.232-.193.47-.239.726-.045.252-.06.51-.067.764-.003.117-.005.234-.005.35L0 3.637V22.78c.001.117.003.234.006.35.007.255.022.512.067.764.046.256.121.494.24.726a2.428 2.428 0 0 0 1.067 1.067c.232.119.47.194.726.24.252.045.509.06.764.067.116.003.233.004.35.005l.417.001h33.339l.416-.001c.117 0 .234-.002.351-.005.255-.007.512-.022.764-.067.256-.046.494-.121.726-.24A2.425 2.425 0 0 0 40.3 24.62c.119-.232.194-.47.24-.726.045-.252.06-.51.066-.763.004-.117.005-.234.006-.351V3.637 3.22c0-.116-.002-.233-.006-.35a5.067 5.067 0 0 0-.067-.764A2.448 2.448 0 0 0 38.507.073a5.115 5.115 0 0 0-.764-.067 17.517 17.517 0 0 0-.35-.005L36.975 0z",
    fill: "#999"
  }), __jsx("path", {
    d: "M36.976.867h.41c.112.001.223.002.334.006.195.005.422.015.634.053.184.033.339.084.487.16a1.566 1.566 0 0 1 .688.688c.075.147.125.3.158.486.038.21.048.438.054.634a56.031 56.031 0 0 1 .006.744v18.725l-.001.413c0 .11-.002.22-.005.331a4.297 4.297 0 0 1-.054.635 1.68 1.68 0 0 1-.158.485 1.566 1.566 0 0 1-.69.689 1.698 1.698 0 0 1-.483.158c-.217.038-.453.049-.632.054-.112.002-.224.004-.338.004-.136.002-.273.001-.41.001H3.225l-.331-.005a4.41 4.41 0 0 1-.634-.054 1.706 1.706 0 0 1-.488-.16 1.555 1.555 0 0 1-.687-.687 1.701 1.701 0 0 1-.158-.487 4.286 4.286 0 0 1-.054-.633 16.216 16.216 0 0 1-.005-.332V3.226c0-.11.002-.222.005-.333a4.29 4.29 0 0 1 .054-.634c.033-.184.083-.338.159-.486a1.564 1.564 0 0 1 .688-.688c.147-.075.302-.126.486-.159.212-.038.439-.048.634-.054.11-.003.222-.004.332-.004l.412-.001h33.338z",
    fill: "#fff"
  }), __jsx("path", {
    d: "M11.085 8.745c.348-.435.584-1.02.521-1.616-.509.025-1.13.336-1.49.771-.322.373-.608.981-.534 1.553.572.05 1.143-.285 1.503-.708zM11.601 9.565c-.83-.05-1.535.47-1.932.47-.396 0-1.003-.445-1.66-.433-.854.012-1.646.495-2.08 1.264-.892 1.536-.235 3.816.632 5.068.421.62.929 1.3 1.597 1.276.632-.024.88-.409 1.648-.409.767 0 .99.41 1.659.397.693-.012 1.127-.62 1.548-1.24.483-.705.68-1.387.693-1.424-.012-.013-1.337-.521-1.35-2.045-.012-1.276 1.04-1.883 1.09-1.92-.594-.88-1.523-.98-1.845-1.004zM18.825 7.838c1.804 0 3.06 1.243 3.06 3.053 0 1.817-1.282 3.067-3.105 3.067h-1.997v3.175H15.34V7.838h3.485zm-2.042 4.908h1.655c1.256 0 1.971-.676 1.971-1.848 0-1.173-.715-1.843-1.964-1.843h-1.662v3.691zM22.262 15.207c0-1.185.908-1.913 2.519-2.003l1.855-.11v-.521c0-.754-.51-1.205-1.36-1.205-.805 0-1.307.386-1.43.992h-1.314c.078-1.224 1.121-2.126 2.796-2.126 1.643 0 2.693.87 2.693 2.229v4.67h-1.334V16.02h-.032c-.393.754-1.25 1.23-2.139 1.23-1.327 0-2.254-.824-2.254-2.042zm4.374-.612v-.534l-1.669.103c-.83.058-1.301.425-1.301 1.005 0 .592.49.979 1.237.979.973 0 1.733-.67 1.733-1.553zM29.28 19.627v-1.128c.102.026.334.026.45.026.644 0 .992-.27 1.205-.966 0-.013.122-.413.122-.42l-2.448-6.782h1.508l1.713 5.514h.026l1.714-5.514h1.468l-2.538 7.13c-.58 1.644-1.25 2.172-2.654 2.172-.116 0-.464-.013-.567-.032z",
    fill: "#999"
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "a"
  }, __jsx("path", {
    fill: "#fff",
    d: "M0 0h40.613v26H0z"
  }))));
};
ApplePayDisabled.defaultProps = {
  viewBox: "-2 -2 44 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BankTransferDisabled = function BankTransferDisabled(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#clip0_8313_28098)"
  }, __jsx("path", {
    d: "M30.817 23.881a.688.688 0 0 0-.686-.686h-.967v-6.867h.144a2.212 2.212 0 0 0 2.21-2.21v-1.056c0-1.22-.989-2.209-2.21-2.209h-2.744l-5.516-5.145a.689.689 0 0 0-.94 0l-5.495 5.145H11.87a2.212 2.212 0 0 0-2.209 2.21v1.056c0 1.22.995 2.209 2.21 2.209h.143v6.867h-.967a.688.688 0 0 0-.686.686c0 .377.309.686.686.686h19.072a.688.688 0 0 0 .686-.686h.014zm-3.025-.686H25.22v-6.867h2.573v6.867zm-7.882-6.867v6.867h-2.573v-6.867h2.573zm1.372 0h2.572v6.867h-2.572v-6.867zm-.693-9.186l3.972 3.704h-7.93l3.958-3.704zm-9.55 6.977v-1.057a.84.84 0 0 1 .837-.837h17.44a.84.84 0 0 1 .836.837v1.057a.84.84 0 0 1-.837.837H11.876a.84.84 0 0 1-.837-.837zm2.36 2.209h2.573v6.867h-2.573v-6.867z"
  }), __jsx("path", {
    d: "M40.992 26.42l-6.34-6.415a.675.675 0 0 0-.747-.151.677.677 0 0 0-.426.631v2.724h-1.152a.688.688 0 0 0-.686.686c0 .377.309.686.686.686h1.838a.688.688 0 0 0 .686-.686v-1.743l4.686 4.747-4.686 4.748v-1.743a.688.688 0 0 0-.686-.686h-11.21a.688.688 0 0 0-.685.686c0 .378.308.686.686.686h10.523v2.73a.68.68 0 0 0 .426.632.67.67 0 0 0 .748-.15l6.339-6.415c.26-.268.26-.7 0-.968zM8.857 9.42H7.02a.688.688 0 0 0-.686.687v1.742L1.647 7.102l4.686-4.747v1.742c0 .378.308.686.686.686h11.21a.688.688 0 0 0 .686-.686.688.688 0 0 0-.686-.686H7.705V.688a.685.685 0 1 0-1.173-.48L.199 6.621c-.26.267-.26.7 0 .967l6.34 6.415a.698.698 0 0 0 .747.157.68.68 0 0 0 .426-.638V10.8h1.152a.688.688 0 0 0 .686-.686.688.688 0 0 0-.686-.686l-.007-.007z"
  })));
};
BankTransferDisabled.defaultProps = {
  viewBox: "-2 -1 45 36",
  fill: "#a4a4a4",
  xmlns: "http://www.w3.org/2000/svg"
};
var CashOnDeliveryDisabled = function CashOnDeliveryDisabled(props) {
  return __jsx("svg", props, __jsx("g", {
    clipPath: "url(#clip0_8313_28091)",
    fill: "#a4a4a4"
  }, __jsx("path", {
    d: "M33.486 23.62l-.724-.489a.642.642 0 0 0-.838.108l-.451.521-.636-.356c-.247-.8-1.143-2.947-3.773-3.335-1.836-.267-4.867.921-4.994.972l-4.663 1.849a2.014 2.014 0 0 0-1.112 1.08 2.002 2.002 0 0 0-.025 1.544c.019.05.05.095.076.14l-3.805.298-1.976-2.56a2.219 2.219 0 0 0-3.1-.394 2.213 2.213 0 0 0-.4 3.1l2.522 3.265s.019.026.031.039c.33.482.826.813 1.385.927l6.912 1.55c.058.02.115.032.16.038l.107.026a2.22 2.22 0 0 0 .845.006c.26-.032.496-.089.712-.178l5.146-2.045 1.003.463-.101.115a.625.625 0 0 0-.146.502c.025.184.12.343.273.444l.857.578a.635.635 0 0 0 .712-1.055l-.267-.177 5.28-6.112.26.178a.635.635 0 1 0 .712-1.055l.018.013zm-8.303 4.848a.626.626 0 0 0-.502-.013l-5.393 2.14a2.204 2.204 0 0 1-.458.109.9.9 0 0 1-.368 0l-.115-.026-.114-.025-6.957-1.563a.976.976 0 0 1-.616-.419c-.019-.025-.038-.05-.063-.076l-2.529-3.272a.935.935 0 0 1 .172-1.315.94.94 0 0 1 1.315.165L11.74 27c.134.172.337.26.553.248l5.851-.457h.013l.305-.026s.019 0 .025-.006c.14-.026.273-.058.407-.108l4.409-1.747a.64.64 0 0 0 .355-.826.64.64 0 0 0-.825-.356l-4.41 1.747a.864.864 0 0 1-.253.05h-.045a.73.73 0 0 1-.673-.47.752.752 0 0 1 .419-.971l4.663-1.849c.788-.311 3.094-1.08 4.34-.896 2.28.337 2.769 2.535 2.788 2.624a.659.659 0 0 0 .311.432l.642.356-3.85 4.453-1.588-.73h.006z"
  }), __jsx("path", {
    d: "M8.254 20.596c.42-.47.814-.864 1.182-1.213l.12.464a2.317 2.317 0 0 0 2.828 1.645 2.28 2.28 0 0 0 1.43-1.13 2.307 2.307 0 0 0 1.803.273 2.3 2.3 0 0 0 1.284-.903c.406.337.927.54 1.474.54a2.3 2.3 0 0 0 2.243-2.82h12.356c.35 0 .635-.286.635-.636V.636A.637.637 0 0 0 32.974 0H8.165a.637.637 0 0 0-.635.635v6.353L5.548 6.57a.62.62 0 0 0-.52.12L.44 10.217a.63.63 0 0 0-.114.889.625.625 0 0 0 .502.248.637.637 0 0 0 .387-.134l4.358-3.354 1.957.413v5.578c-2.02.877-3.64.737-3.66.737a.635.635 0 1 0-.133 1.264c.134.013 3.266.318 6.487-2.11 1.207-.908 2.293-1.308 3.043-1.13.495.12.73.464.826.654.362.731-.394 1.754-1.976 2.675-.083.045-.178.095-.292.159-.813.42-2.319 1.2-4.51 3.634C5.04 22.267 2.415 22.87.617 22.928a.632.632 0 0 0-.61.654.638.638 0 0 0 .636.616h.025c2.046-.07 5.019-.75 7.598-3.608l-.013.006zm3.8-.336a1.038 1.038 0 0 1-1.271-.737l-.28-1.068a10.862 10.862 0 0 1 1.512-1.003h.369l.406 1.543s.007.026.013.032a1.036 1.036 0 0 1-.743 1.233h-.007zm3.227-.852a1.038 1.038 0 0 1-1.258-.705v-.032l-.324-1.22h2.14l.185.706a1.04 1.04 0 0 1-.737 1.258l-.006-.007zm4.085-1.709a1.038 1.038 0 1 1-2.008.534l-.101-.394v-.019l-.096-.362h2.148l.063.248-.006-.007zm-5.807-6.308c-.476-.114-.99-.095-1.544.038V6.804a3.284 3.284 0 0 0 2.96-2.929h2.307c-1.283 1.118-2.116 2.878-2.116 4.854s.833 3.73 2.116 4.847H15.44a2.194 2.194 0 0 0-.21-.857 2.472 2.472 0 0 0-1.67-1.328zm11.188 2.185h-.909c1.284-1.118 2.116-2.878 2.116-4.847 0-1.97-.832-3.73-2.116-4.854h2.313a3.284 3.284 0 0 0 2.96 2.929v3.844a3.278 3.278 0 0 0-2.96 2.928h-1.404zm-.07-4.847c0 2.675-1.849 4.847-4.117 4.847s-4.117-2.172-4.117-4.847c0-2.675 1.85-4.854 4.117-4.854 2.268 0 4.117 2.18 4.117 4.854zm-9.549 6.118h11.658a.635.635 0 0 0 .635-.705l-.012-.102c0-.044-.013-.089-.013-.14a2 2 0 0 1 2.001-2c.083 0 .165.005.248.018a.664.664 0 0 0 .508-.146.636.636 0 0 0 .216-.483V6.137a.623.623 0 0 0-.216-.476.63.63 0 0 0-.502-.153l-.076.013c-.057.006-.12.019-.178.019a2 2 0 0 1-2.001-2.001c0-.083.006-.16.019-.235a.643.643 0 0 0-.159-.496.64.64 0 0 0-.476-.21H14.334a.636.636 0 0 0-.629.7c.007.075.02.158.02.24a2 2 0 0 1-2.002 2.002c-.063 0-.12-.013-.178-.02l-.076-.012a.636.636 0 0 0-.718.629v5.775c-.413.216-.845.489-1.29.82-.222.165-.444.31-.66.45V1.271h23.531v14.91H14.017c.552-.47.908-.921 1.124-1.334h-.013z"
  })));
};
CashOnDeliveryDisabled.defaultProps = {
  viewBox: "-2 -2 38 35",
  xmlns: "http://www.w3.org/2000/svg"
};
var AutopayDisabled = function AutopayDisabled(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M17.924 10.793c0-5.111-3.872-9.254-8.962-9.254S0 5.682 0 10.793v18.508h2.24c0-3.833 3.01-6.94 6.722-6.94 3.712 0 6.722 3.108 6.722 6.94h2.24V10.793z",
    fill: "#cbcbcb"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.402 0l-5.755 29.302h5.11l1.112-6.434h6.35l1.111 6.434h5.26L37.833 0h-7.432zm1.181 18.852l2.46-14.14 2.46 14.14h-4.92z",
    fill: "#a9a9a9"
  }), __jsx("path", {
    d: "M54.968 22.58c0 2.09-1.151 3.116-2.7 3.116-1.547 0-2.222-.902-2.222-2.829V7.868h-4.922v15.655c0 4.18 2.064 6.147 5.08 6.147 2.461 0 3.97-1.27 4.764-3.033V29.3h4.921V7.868h-4.921v14.713zM62.811 3.565h4.921V7.87h3.374v3.73h-3.374v11.72c0 1.475.595 2.13 1.865 2.13.636 0 1.23-.082 1.509-.205v3.893c-.397.164-1.35.328-2.46.328-4.089 0-5.835-1.885-5.835-5.737V3.565z",
    fill: "#a9a9a9"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.424 7.5c-4.524 0-7.779 2.745-7.779 8.032v6.188c0 5.205 3.255 7.95 7.74 7.95 4.484 0 7.897-2.745 7.897-8.032V15.45c0-5.246-3.294-7.95-7.858-7.95zm2.898 14.344c0 2.622-.952 3.934-2.898 3.934-1.945 0-2.858-1.312-2.858-3.934v-6.557c0-2.663.993-3.934 2.858-3.934 1.865 0 2.898 1.27 2.898 3.975v6.516zM95.664 10.492c.834-1.64 2.46-2.992 4.842-2.992 3.532 0 5.874 2.458 5.874 7.58v6.927c0 5.164-2.461 7.663-6.072 7.663-2.303 0-3.93-1.188-4.644-2.827V36h-4.922V7.87h4.922v2.622zm2.976 15.327c1.826 0 2.779-1.189 2.779-3.77v-6.967c0-2.663-1.033-3.688-2.78-3.688-1.904 0-3.016 1.352-3.016 4.016v6.352c0 2.663.993 4.057 3.017 4.057zM119.244 10.328c-.754-1.721-2.143-2.828-4.445-2.828-3.493 0-6.112 2.5-6.112 7.704v6.804c0 5.204 2.46 7.663 5.874 7.663 2.381 0 3.889-1.352 4.683-3.074v2.705h4.922V7.869h-4.922v2.46zm.04 11.393c0 2.663-1.112 4.057-3.017 4.057-1.667 0-2.619-1.066-2.619-3.688v-6.967c0-2.664.952-3.812 2.739-3.812 1.905 0 2.898 1.394 2.898 4.14l-.001 6.27z",
    fill: "#a9a9a9"
  }), __jsx("path", {
    d: "M134.043 20.9l3.135-13.032H142L134.027 36h-4.938l2.454-8.42-5.994-19.712h5.239l3.255 13.032z",
    fill: "#a9a9a9"
  }));
};
AutopayDisabled.defaultProps = {
  viewBox: "0 0 142 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PaypalDisabled = function PaypalDisabled(props) {
  return __jsx("svg", props, __jsx("rect", {
    rx: "15%",
    fill: "none"
  }), __jsx("path", {
    fill: "#b1b1b1",
    d: "M377 184.8L180.7 399h-72c-5 0-9-5-8-10l48-304c1-7 7-12 14-12h122c84 3 107 46 92 112z"
  }), __jsx("path", {
    fill: "#c9c9c9",
    d: "M380.2 165c30 16 37 46 27 86-13 59-52 84-109 85l-16 1c-6 0-10 4-11 10l-13 79c-1 7-7 12-14 12h-60c-5 0-9-5-8-10l22-143c1-5 182-120 182-120z"
  }), __jsx("path", {
    fill: "#adadad",
    d: "M197 292l20-127a14 14 0 0 1 13-11h96c23 0 40 4 54 11-5 44-26 115-128 117h-44c-5 0-10 4-11 10z"
  }));
};
PaypalDisabled.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};
var Przelewy24Disabled = function Przelewy24Disabled(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#b1b1b1",
    d: "M409.6 384.9l156.4-.2-5.7 35.6-130.8 124.9 109.8-.2-6.4 38.4-161.7.1 6.8-39.7 125.4-120.1H403.3l6.3-38.8zM238.5 324c-3.4-3.6-8.3-6.4-13.7-8.6-5.7-2.2-12-3.8-18.2-4.9-7.8-1.4-15.4-2-20.8-2.2-5-.2-8.2-.2-8.2-.2H58.3L12.7 583.5h42.6l16.8-102 82.6.4s32.2 1.3 55-10.8c22.8-12.1 28.9-39.6 28.9-39.6s2.5-10.2 4.6-22.6c2.3-13.7 4.6-30.1 5.8-38.8.5-3.8.8-6.2.8-6.2s.6-2.8.6-7.2c.1-6.1-.8-15.3-5.6-24.1-1.7-3.1-3.7-5.9-6.3-8.6zm-32.8 48.6c0 .5-3.8 22.6-8.8 48.8-1.9 10-9.6 15.4-18.4 17.3-14.6 3.1-30.3 2.5-30.3 2.5l-69-.2 15.2-91.5 62.5.2s4.2-.1 10.1 0c6.7.1 15.6.4 22.9 1.4 6.3.8 11.3 2.1 12.9 4.1 2.1 2.6 2.9 6 3.2 9 .4 4.4-.3 8.1-.3 8.4zM778.1 308.1h41l-45.9 275.4-41.1-.1 46-275.3zM996.9 384.9l39.3-.1 13.9 139.8 60.5-140 48.5.1 14.3 140.4 60.4-140.3h40.8L1188 583.3h-48.4l-14-139-61.1 139-47.6.2-20-198.6z"
  }), __jsx("g", {
    fill: "#b1b1b1"
  }, __jsx("path", {
    d: "M702.4 386.5c-11.5-3.7-31.4-4.5-48.3-4.3-16.3.2-23.8 1-29.9 2.3 0 0-29 4.2-45.5 24.6-16.5 20.4-21.4 65-21.4 65s-9.8 49.3-6.9 65.8c2.9 16.4 8 31.7 26.6 38.8 18.6 7.2 34.4 6.8 34.4 6.8s33.2 2.6 58.2-3.3 38.2-23.5 38.2-23.5 5.9-7.6 10.1-16.6c4.2-9 5.5-15.3 5.7-16.1l2.6-10.7-42.5.1s-2.3 28.1-25.3 30.7c-22.9 2.6-35.2 1.6-39.7 1.4-4.4-.2-29 .9-27-19.7 0-.3 0-.7.1-1.3 1.1-23.4 3.7-29.5 3.7-29.5l133.5-.4 5.7-33c6.6-37.4 1.9-65.9-32.3-77.1zm-8.9 72.4l-91.5-.1 3.6-14.5s3.2-11.4 9.5-16.2c6.4-4.8 14.5-5.7 22.1-6.4 7.6-.7 27.9-2.2 44.4 1.2 5.5 1.1 10.7 4.2 12.1 8.8 3.2 10.8-.2 27.2-.2 27.2z"
  }), __jsx("path", {
    d: "M592 526.9c0 .3-.1.6-.1.9-.1 1.6.1-1 .1-.9z"
  })), __jsx("g", {
    fill: "#b1b1b1"
  }, __jsx("path", {
    d: "M843.8 527c0 .3-.1.6-.1.9 0 1.6.1-1 .1-.9z"
  }), __jsx("path", {
    d: "M954.3 386.6c-11.5-3.7-31.4-4.5-48.3-4.3-16.3.2-23.8 1-29.9 2.3 0 0-29 4.2-45.5 24.6-16.5 20.4-21.4 65-21.4 65s-9.8 49.3-6.9 65.8c2.9 16.4 8 31.7 26.6 38.8 18.6 7.2 34.4 6.8 34.4 6.8s33.2 2.6 58.2-3.3 38.2-23.5 38.2-23.5 5.9-7.6 10.1-16.6c4.2-9 5.5-15.3 5.7-16.1l2.6-10.7-42.5.1s-2.3 28.1-25.3 30.7c-22.9 2.6-35.2 1.6-39.7 1.5-4.4-.2-29 .8-27-19.7 0-.3 0-.7.1-1.3 1.1-23.4 3.7-29.5 3.7-29.5l133.5-.4 5.7-33c6.6-37.5 1.9-66.1-32.3-77.2zm-9.3 72.3l-91.5-.1 3.6-14.5s3.2-11.4 9.5-16.2c6.3-4.8 14.5-5.7 22.1-6.4 7.6-.7 27.9-2.2 44.4 1.2 5.5 1.1 10.7 4.2 12.1 8.8 3.2 10.7-.2 27.2-.2 27.2z"
  })), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#b1b1b1",
    d: "M1321.8 384.9l26.3 145.2 74.3-145.3 41.8.4-107.1 207.5s-19.4 37.6-31.4 47.1-19.4 13.8-29.2 14.8-13.8 1.7-23.2 0l-10-1.8 6.2-37.1s16.6 3.1 26.4-.8c9.9-3.9 17.8-20.7 17.8-20.7l5-8.4-38.7-201 41.8.1z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B3B2B1",
    d: "M1479.4 404.6l43.1.1 2.6-16.7s4.6-30.2 14.9-36c3.3-1.9 8.6-3.6 14.7-4.7 11.3-2 25.6-2.2 37.3-1.8 17.9.6 24.7.8 42.9 2.9 18.2 2.1 13.6 19.7 13.6 19.7l-3.6 26.3s-1.6 11.8-5.8 19.1c-3.7 6.5-13.9 10.9-19.8 12.8-14.2 4.6-62.8 17-62.8 17l-38.2 11s-23.5 6.8-36.6 21.3c-13.2 14.6-18.4 31.1-20.2 39.7-1.8 8.6-11.9 68.1-11.9 68.1l206.2.1 6.9-41.2-163.1.2 2.9-16.8s1.9-17.3 8.9-23c2.2-1.8 3.3-4.2 16.3-8.8 7.8-2.8 34.4-9.9 34.4-9.9l61.5-16.8s33.6-8.6 46.8-27c13.2-18.3 18.3-53.4 18.3-53.4s3.6-34.1.8-44.8c-2.7-10.7-12.8-23.5-25.1-29s-25.1-8.7-62.2-8.2-55.5 2.2-74.3 9.2c-18.8 6.9-29.7 19.5-36.6 37.3-7.5 16.9-11.9 53.3-11.9 53.3zM1867.6 481.2l28.9-173.2h-51.2l-159.4 171.2-7.2 43.4h139.4l-10.2 60.8 42.8.1 10.1-60.9 39.5.1 7.1-41.5h-39.8zm-42.6.1l-90.1-.1 109.7-116.9-19.6 117zM328.9 330.8h131.3s29.4-23.8 50.3-39.1 58.9-39.4 58.9-39.4l-74.2-34.7s-62.7 38.8-89.3 57.1c-25.8 16.9-77 56.1-77 56.1zM611.1 227.8l-60.9-41s55.1-31.3 128.4-60.5c73.2-29.2 112.3-41.4 112.3-41.4l12.4 58.1s-70.5 23.6-110.9 42.7c-41.8 17.8-81.3 42.1-81.3 42.1zM848.3 130.3l-10.6-59.5s75.2-20 144-32.8c68.9-12.8 160.2-18.9 160.2-18.9l-30.2 91.9s-80.3-11-155.7-.7c-58.7 7-107.7 20-107.7 20zM1159.5 118.8l50.8-102.1s111.3-2.2 207.3 12.7c96 14.8 183.8 37.6 181.9 38.6l-243.4 127.3s-56.9-36-127.5-58.1c-40-11.8-69.1-18.4-69.1-18.4zM1399.7 223l53.5 40.6h439.7s-.9-14.2-12.6-34.4c-7.3-12.6-20.6-26-34.5-39.9-5.1-5-25.3-20.8-40.5-30.7-38.8-25.2-60.5-34.9-100.8-53.2L1399.7 223z"
  }), __jsx("path", {
    fill: "#b1b1b1",
    d: "M357.4 384.7c-16.5 0-32.1 6.5-45.4 13.8l2.3-13.8h-43.7l-35 197.7h43.8l19.4-109.5c4-22.2 20.6-49.7 53-49.7l22.6-.1 6.8-38.4h-23.8z"
  }));
};
Przelewy24Disabled.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1920 672"
};
var BlikDisabled = function BlikDisabled(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.63C0 .73.733 0 1.634 0h32.601c.903 0 1.635.735 1.635 1.63v21.74c0 .9-.733 1.63-1.635 1.63h-32.6A1.636 1.636 0 0 1 0 23.37V1.63z",
    fill: "#a8a8a8"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.145 18.847h2.182V6.618h-2.183v12.229zM19.191 18.846h2.183v-8.1h-2.183v8.1zM31.158 18.847l-3.28-4.287 3.017-3.813h-2.577l-2.893 3.7V6.617h-2.183v12.229h2.183v-4.159l2.893 4.159h2.84zM9.58 16.756a1.96 1.96 0 1 1 0-3.918 1.96 1.96 0 0 1 0 3.918zm0-6.1c-.71 0-1.376.178-1.96.491V6.618H5.437v8.179a4.142 4.142 0 1 0 4.142-4.142z",
    fill: "#FFFFFE"
  }), __jsx("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: "9",
    y: "6",
    width: "5",
    height: "4"
  }, __jsx("path", {
    d: "M13.658 7.96a1.946 1.946 0 1 1-3.892 0 1.946 1.946 0 0 1 3.892 0z",
    fill: "#fff"
  })), __jsx("g", {
    mask: "url(#a)"
  }, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.658 7.96a1.946 1.946 0 1 1-3.892 0 1.946 1.946 0 0 1 3.892 0z",
    fill: "url(#b)"
  })), __jsx("defs", null, __jsx("linearGradient", {
    id: "b",
    x1: "10.455",
    y1: "6.013",
    x2: "12.97",
    y2: "9.905",
    gradientUnits: "userSpaceOnUse"
  }, __jsx("stop", {
    stopColor: "#bababa"
  }), __jsx("stop", {
    offset: "1",
    stopColor: "#bababa"
  }))));
};
BlikDisabled.defaultProps = {
  viewBox: "0 0 36 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var iconList = [{
  type: "dialcom_przelewy",
  icon: __jsx(Przelewy24, null),
  iconDisabled: __jsx(Przelewy24Disabled, null),
  width: 70,
  detailIcons: {
    de: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    cz: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    es: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    fr: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    pl: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }, {
      icon: __jsx(Blik, null),
      background: "#000000"
    }],
    it: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    gb: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    ro: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    se: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    sk: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }]
  }
}, {
  type: "paypal_express",
  icon: __jsx(Paypal, null),
  iconDisabled: __jsx(PaypalDisabled, null),
  width: 30,
  detailIcons: {}
}, {
  type: "bluepayment",
  icon: __jsx(Autopay, null),
  iconDisabled: __jsx(AutopayDisabled, null),
  width: 63,
  detailIcons: {
    de: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    cz: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    es: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    fr: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    pl: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }, {
      icon: __jsx(Blik, null),
      background: "#000000"
    }, {
      icon: __jsx(GooglePay, null),
      background: "none"
    }, {
      icon: __jsx(PayPo, null),
      background: "none"
    }],
    it: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    gb: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    ro: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    se: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }],
    sk: [{
      icon: __jsx(Visa, null),
      background: "none"
    }, {
      icon: __jsx(MasterCard, null),
      background: "none"
    }]
  }
}, {
  type: "banktransfer",
  icon: __jsx(BankTransfer, null),
  iconDisabled: __jsx(BankTransferDisabled, null),
  width: 43,
  detailIcons: {}
}, {
  type: "cashondelivery",
  icon: __jsx(CashOnDelivery, null),
  iconDisabled: __jsx(CashOnDeliveryDisabled, null),
  width: 36,
  detailIcons: {}
}, {
  type: "tablerate",
  icon: "",
  iconDisabled: "",
  width: 85,
  detailIcons: {
    de: [{
      icon: __jsx(Dhl, null),
      background: "none"
    }, {
      icon: __jsx(Geis, null),
      background: "none"
    }],
    es: [{
      icon: __jsx(Dhl, null),
      background: "none"
    }, {
      icon: __jsx(Ups, null),
      background: "none"
    }],
    fr: [{
      icon: __jsx(Dhl, null),
      background: "none"
    }, {
      icon: __jsx(Ups, null),
      background: "none"
    }],
    pl: [{
      icon: __jsx(Inpost, null),
      background: "none"
    }, {
      icon: __jsx(Ups, null),
      background: "none"
    }, {
      icon: __jsx(Dhl, null),
      background: "none"
    }, {
      icon: __jsx(Geis, null),
      background: "none"
    }, {
      icon: __jsx(Dpd, null),
      background: "none"
    }],
    it: [{
      icon: __jsx(Dhl, null),
      background: "none"
    }, {
      icon: __jsx(Ups, null),
      background: "none"
    }],
    gb: [{
      icon: __jsx(Dhl, null),
      background: "none"
    }, {
      icon: __jsx(Ups, null),
      background: "none"
    }],
    ro: [{
      icon: __jsx(Dhl, null),
      background: "none"
    }, {
      icon: __jsx(Ups, null),
      background: "none"
    }],
    se: [{
      icon: __jsx(Dhl, null),
      background: "none"
    }, {
      icon: __jsx(Ups, null),
      background: "none"
    }],
    sk: [{
      icon: __jsx(Dpd, null),
      background: "none"
    }],
    cz: [{
      icon: __jsx(Dpd, null),
      background: "none"
    }]
  }
}, {
  type: "inpostlocker",
  icon: "",
  iconDisabled: "",
  width: 190,
  detailIcons: {
    de: [{
      icon: __jsx(Inpost24, null),
      background: "none"
    }],
    cz: [{
      icon: __jsx(Inpost24, null),
      background: "none"
    }],
    es: [{
      icon: __jsx(Inpost24, null),
      background: "none"
    }],
    fr: [{
      icon: __jsx(Inpost24, null),
      background: "none"
    }],
    pl: [{
      icon: __jsx(Inpost24, null),
      background: "none"
    }],
    it: [{
      icon: __jsx(Inpost24, null),
      background: "none"
    }],
    gb: [{
      icon: __jsx(Inpost24, null),
      background: "none"
    }],
    ro: [{
      icon: __jsx(Inpost24, null),
      background: "none"
    }],
    se: [{
      icon: __jsx(Inpost24, null),
      background: "none"
    }],
    sk: [{
      icon: __jsx(Inpost24, null),
      background: "none"
    }]
  }
}, {
  type: "blik",
  icon: __jsx(Blik, null),
  iconDisabled: __jsx(BlikDisabled, null),
  width: 36,
  detailIcons: {}
}, {
  type: "card",
  icon: __jsx(Card, null),
  iconDisabled: __jsx(CardDisabled, null),
  width: 34,
  detailIcons: {}
}, {
  type: "klarna",
  icon: __jsx(Klarna, null),
  iconDisabled: __jsx(KlarnaDisabled, null),
  width: 47,
  detailIcons: {}
}, {
  type: "klarna_paynow",
  icon: __jsx(Klarna, null),
  iconDisabled: __jsx(KlarnaDisabled, null),
  width: 47,
  detailIcons: {}
}, {
  type: "klarna_account",
  icon: __jsx(Klarna, null),
  iconDisabled: __jsx(KlarnaDisabled, null),
  width: 47,
  detailIcons: {}
}, {
  type: "googlepay",
  icon: __jsx(GooglePay, null),
  iconDisabled: __jsx(GooglePayDisabled, null),
  width: 52,
  detailIcons: {}
}, {
  type: "applepay",
  icon: __jsx(ApplePay, null),
  iconDisabled: __jsx(ApplePayDisabled, null),
  width: 42,
  detailIcons: {}
}, {
  type: "scheme",
  icon: __jsx(Card, null),
  iconDisabled: __jsx(CardDisabled, null),
  width: 34,
  detailIcons: {}
}];
var _default = iconList;
exports["default"] = _default;

/***/ }),

/***/ 83556:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _iconList = _interopRequireDefault(__webpack_require__(13233));
var __jsx = _react["default"].createElement;
var mainIcon = function mainIcon(props) {
  var _icon$width, _icon$iconDisabled, _icon$icon;
  var icon = _iconList["default"].find(function (method) {
    return method.type === props.type;
  });
  return __jsx(_Box["default"], {
    sx: {
      minWidth: (_icon$width = icon === null || icon === void 0 ? void 0 : icon.width) !== null && _icon$width !== void 0 ? _icon$width : 0,
      maxWidth: props.minified ? 15 : "auto",
      p: props.minified ? 0 : "s3",
      display: icon !== null && icon !== void 0 && icon.icon ? "block" : "none"
    }
  }, props.disabled ? (_icon$iconDisabled = icon === null || icon === void 0 ? void 0 : icon.iconDisabled) !== null && _icon$iconDisabled !== void 0 ? _icon$iconDisabled : "" : (_icon$icon = icon === null || icon === void 0 ? void 0 : icon.icon) !== null && _icon$icon !== void 0 ? _icon$icon : "");
};
var _default = mainIcon;
exports["default"] = _default;

/***/ })

}]);